import { Options, LabelType } from "ng5-slider";
import { NumberFormatDirectiveDirective } from "../directive/number-format-directive.directive";
import { DeviceDetectorService } from "ngx-device-detector";
import { HttpRequestService } from "../http-request.service";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { KycModalComponent } from "../modals/kyc-modal/kyc-modal.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateAdapter } from "@angular/material/core";
import { SharedService } from "../shared.service";
import { NgxAutoScroll } from "ngx-auto-scroll";
import { DialogComponent } from "../modals/dialog/dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { Session } from "protractor";
import { IfStmt, ReturnStatement } from "@angular/compiler";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  Inject,
  Renderer2,
} from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { DatePipe } from "@angular/common";
import { SenderService } from "../sender.service";
import { connectableObservableDescriptor } from "rxjs/internal/observable/ConnectableObservable";
import { Injectable } from "@angular/core";
import { AnyRecord } from "dns";
import { SdDreamCamComponent } from "../0-shared-components/sd-dream-cam/sd-dream-cam.component";
import {
  collapseTextChangeRangesAcrossMultipleVersions,
  createFalse,
  ScriptElementKindModifier,
} from "typescript";
import { EventListenerFocusTrapInertStrategy } from "@angular/cdk/a11y";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { pipeline } from "stream";
import { delay } from "rxjs/operators";
import { AppComponent } from "../app.component";
declare const gtag: Function;
import { DOCUMENT } from "@angular/common";
import { truncate } from "fs";
import { error } from "console";
import { invalid } from "@angular/compiler/src/render3/view/util";
import { Timestamp } from "rxjs/internal/operators/timestamp";
import { parse } from "path";

@Component({
  selector: "app-chat-section",
  templateUrl: "./chat-section.component.html",
  styleUrls: ["./chat-section.component.scss"],
})
export class ChatSectionComponent implements OnInit {
  @Input() retryObservable: Subject<void>;
  @Input() snapshotObservable: Subject<void>;
  @Output() snapshotEvent = new EventEmitter();
  @Output() cameraErrorEvent = new EventEmitter();
  @Input() SelfieStatus = new EventEmitter();
  @ViewChild("videoPlayer") videoPlayer: ElementRef;
  @ViewChild("outputImage") outputImage: ElementRef;
  datePipe: DatePipe = new DatePipe("en-US");
  imageHeight = 0;
  currentStream = null;
  cameraError = false;
  loading = true;
  timestamp: String = "";
  emandateStatus: any = "Proceed for e-Mandate";
  availableDevices = [];
  currentDevice = -1;
  adjustImageHeight = true;
  @ViewChild(NgxAutoScroll) ngxAutoScroll: NgxAutoScroll;
  userDetailForm: FormGroup;
  professionForm: FormGroup;
  residenceForm: FormGroup;
  bankingDetailForm: FormGroup;
  otpForm: FormGroup;
  empDetails: FormGroup;
  personalForm: FormGroup;
  kyc_decision: any;
  kyc_decision_status: any;
  dmiKYCWindow: Window;
  checkDmiKYCWindowInterval: any;
  disable1: boolean = false;
  routerKey: any = "";
  isYes: boolean;
  isYes1: boolean;
  deviceInfo: any = "";
  deviceType: any = "";
  ifscError: any = "";
  wrongOTP: any = "";
  kycStatus: any = "Proceed";
  kycStatus1: any = "Proceed";
  googleAppID: any = "";
  requestId: any = "";
  offerResponse: any = "";
  selectedCheck: any = 1;
  isDisabled: boolean;
  isDisabled1: boolean;
  isShowBankingForm: boolean;
  isEmpTypeSubmitted: boolean;
  isLoanOfferCheck: boolean = false;
  isOfferSelected: boolean = false;
  showLoader: boolean = false;
  isEMandateCompleted: boolean = false;
  isbankingSubmit: boolean = false;
  isKYCSuccess: boolean = false;
  isSubmittedComm: boolean = false;
  otpOption: boolean = false;
  isContinueWithUserName: boolean;
  isSelectedLoanRange: boolean;
  initialPersonalInfo: boolean = true;
  editable: boolean = true;
  showOfferResp: boolean = false;
  intialPersonalForm: boolean;
  isFiledPersonalFormStatus: boolean;
  initialPersonalForm: boolean;
  empInitialInfo: boolean = true;
  empInitialForm: boolean;
  empInfoStatus: boolean;
  afterVerifedOTP: boolean;
  afterFilledPersonalInfo: boolean;
  afterIsSalariedSelected: boolean;
  afterFilledEmpInfo: boolean;
  comAddressInitialInfo: boolean;
  comAddressInitialForm: boolean;
  comAddressIntialStatus: boolean;
  isLDSCompleted: boolean = false;
  afterFilledCommunicationInfo: boolean;
  personalFormSub: boolean = false;
  isNotSameAddress: boolean = true;
  isLoanJourneyCompleted: boolean = false;
  isCheckedSameAddress: boolean = true;
  showBankingForm: boolean = false;
  isloanOffersSubmitted: boolean = false;
  showOtpSection: boolean = true;
  showDialog: boolean = false;
  showAAOption: boolean = false;
  showBankSelect: boolean = true;
  emp_details: boolean;
  isSelectLoanAmt: boolean;
  isSelectIncomeAmt: boolean;
  isKYCprocees: boolean;
  afterSlectededOffer: boolean;
  isPANsubmit: boolean;
  isEmailVerified: boolean;
  isBankTypeSubmitted: boolean;
  secondsS: any = 0;
  requiredMsg1: string;
  requiredMsg: string;
  requiredMsg2: string;
  value1 = 150000;
  value2 = 35000;
  value3 = 25000;
  value4 = 6;
  value7 = 30000;
  value8 = 6;
  selected_bank: any;
  maxValue: any;
  bankList: any = [];
  userDetails: any = [];
  userState: any = [];
  alreadyAns: any = [];
  status: any;
  reason: any;
  hideSection: boolean = false;
  dynamicURL: any = "";
  loanNumber: any = "";
  hide1: boolean = false;
  time: any = 0;
  rfc: any;
  insurance_opted: boolean = false;
  GridAmount: any;
  GridEmi: any;
  GridTenor: any;
  GridProcessingFee: any;
  GridRoi: any;
  employment_submitted: boolean = false;
  monthlyIncome:FormGroup
  householdIncome:FormGroup
  @ViewChild("closemodal") closeldsmodal: any;

  // Showing message property
  // Personal Info
  msgStepper_101: boolean;
  msgStepper_102: boolean;
  msgStepper_103: boolean;
  msgStepper_104: boolean;
  msgStepper_105: boolean;
  msgStepper_106: boolean;
  msgStepper_107: boolean;
  msgStepper_108: boolean;
  msgStepper_109: boolean;
  msgStepper_110: boolean;
  msgStepper_111: boolean;
  msgStepper_112: boolean;
  msgStepper_113: boolean;
  msgStepper_114: boolean;

  // Loan Info
  msgStepper_201: boolean;
  msgStepper_202: boolean;
  msgStepper_203: boolean;
  msgStepper_204: boolean;

  // General Information
  msgStepper_301: boolean;
  msgStepper_302: boolean;
  msgStepper_303: boolean;
  msgStepper_304: boolean;
  msgStepper_305: boolean;
  msgStepper_306: boolean;
  msgStepper_307: boolean;
  msgStepper_308: boolean;
  msgStepper_309: boolean;
  msgStepper_310: boolean;
  msgStepper_311: boolean;
  msgStepper_312: boolean;
  msgStepper_313: boolean;
  msgStepper_314: boolean;
  msgStepper_315: boolean;
  msgStepper_316: boolean;
  msgStepper_317: boolean;
  msgStepper_318: boolean;

  // KYC
  msgStepper_401: boolean;
  msgStepper_402: boolean;
  msgStepper_403: boolean;
  msgStepper_404: boolean;
  msgStepper_405: boolean;

  // Communication Details
  msgStepper_501: boolean;
  msgStepper_502: boolean;
  msgStepper_503: boolean;
  msgStepper_504: boolean;
  msgStepper_505: boolean;
  msgStepper_506: boolean;

  // Account Agreegator / Banking Details
  msgStepper_601: boolean;
  msgStepper_602: boolean;
  msgStepper_603: boolean;
  msgStepper_604: boolean;
  msgStepper_605: boolean;
  msgStepper_606: boolean;

  // Employment Details
  msgStepper_701: boolean;
  msgStepper_702: boolean;
  msgStepper_703: boolean;
  msgStepper_704: boolean;

  // Offer
  msgStepper_801: boolean;
  msgStepper_802: boolean;
  msgStepper_803: boolean;
  msgStepper_804: boolean;
  msgStepper_805: boolean;

  // E-mandate
  msgStepper_901: boolean;
  msgStepper_902: boolean;
  msgStepper_903: boolean;
  msgStepper_904: boolean;
  msgStepper_905: boolean;

  // LDS
  msgStepper_1001: boolean;
  msgStepper_1002: boolean;
  msgStepper_1003: boolean;
  msgStepper_1004: boolean;
  msgStepper_1005: boolean;
  msgStepper_1006: boolean;

  // Loan Creation
  msgStepper_1101: boolean;
  msgStepper_1102: boolean;
  msgStepper_1103: boolean;
  msgStepper_1104: boolean;
  msgStepper_1105: boolean;
  msgStepper_1106: boolean;
  msgStepper_1107: boolean;
  msgStepper_1108: boolean;
  msgStepper_1109: boolean;
  msgStepper_1110: boolean;
  msgStepper_1111: boolean;
  msgStepper_1112: boolean;
  msgStepper_1121: boolean;
  msgStepper_112111: boolean;
  msgStepper_Offer: boolean;
  msgStepper_dialog: boolean;
  msgspinner: boolean;
  loadPastData: boolean;

  // jan-7 developer manpreet singh
  isTermAndConditionIsEnable$ = new BehaviorSubject<boolean>(true);
  isHouseHoldIncomeEnable$ = new BehaviorSubject<boolean>(false);
  isOfferRejectionScreenEnable$ = new BehaviorSubject<boolean>(false);

  // Form Field Value
  userName: any;
  mobileNumber: any;
  userPan: any = "";
  userEmail: any = "";
  rateOfInt: any = "";
  approxEMI: any = "";
  // loanTenure:any=[];
  public safePipedContent: SafeUrl;
  // OTP Config
  config = {
    allowNumbersOnly: true,
    length: 5,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      "border-bottom": "1px solid #b7b5b5",
      outline: "none",
      "border-top": "none",
      "border-left": "none",
      "border-right": "none",
      "margin-bottom": "10px",
      height: "24px",
    },
  };

  config1 = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputClass: "otp-input",
    inputStyles: {
      border: "1px solid #b7b5b5",
      outline: "none",
      "border-top": "1px solid #b7b5b5",
      "border-left": "1px solid #b7b5b5",
      "border-right": "1px solid #b7b5b5",
      "margin-bottom": "20px",
      "margin-top": "20px",
      height: "40px",
      width: "100",
    },
  };

  result: any;
  data: any;
  Kycpositionstatus: any;
  aapositionstatus: any;
  emandatepositionstatus: any;
  epositionstatus: any;
  isContinueWithUserName1: boolean;
  msgS_105: boolean;
  msgS_106: boolean;
  stringMob: any;
  Mobile: any;
  reasonForm: FormGroup;
  sfdcmobileNumber: string;
  res: any;
  userStatus: any;
  user_Email: string;
  kyc_flag_status: string;
  msgStepper_selfie: boolean;
  isSelfie: boolean;
  subscription: any;
  otp_flag: string;
  modalref: any;
  offerAmount: any;
  offertenor: string;
  offerroi: string;
  ROIAnnually: any;
  offeremi: any;
  msg7: boolean;
  Partner_Name: string;
  camp_Status: any;
  msg8: boolean;
  msg9: boolean;
  flat: string;
  landmark: string;
  postOffice: string;
  District: string;
  Pincode: string;
  State: string;
  C_Id: any;
  msg20: boolean;
  msg21: boolean;
  msg23: boolean;
  msg22: boolean;
  nach_flag: string;
  nach_flag_status: boolean;
  leadcreated: string;
  msgStepper_907: boolean;
  Application_id: any;
  loader1: boolean;
  MailingCity: any;
  MailingCountry: any;
  MailingStreet: any;
  MailingState: any;
  MailingPostalCode: any;
  residenceForm1: FormGroup;
  msgStepper_1501: boolean;
  msgStepper_1502: boolean;
  msgStepper_30: boolean;
  msgStepper_31: boolean;
  msgStepper_32: boolean;
  dob: any;
  firstname: any;
  lastname: any;
  msgStepper_33: boolean;
  msgStepper_34: boolean;
  msgStepper_35: boolean;
  msgStepper_36: boolean;
  hidebutton1: boolean;
  isnotSameAddress: boolean;
  msgStepper_37: boolean;
  msgStepper_38: boolean;
  msgStepper_39: boolean;
  msgStepper_40: boolean;
  rfcfailed: boolean = false;
  hidebutton2: any;
  iscommupdated1: boolean;
  msgStepper_50: boolean;
  comnadress: any;
  comnaddress: string;
  Selfie_status: any;
  loader3: boolean;
  msgStepper_391: boolean;
  msgStepper_392: boolean;
  hidebutton7: any;
  showLoader1: boolean = false;
  mandate_decision: any;
  isDisabled2: boolean;
  msgStepper_80: boolean;
  isKYCReject: boolean = false;
  msgStepper_61: boolean;
  msgStepper_62: boolean;
  msg_61: boolean;
  msgStepper_1010: boolean;
  msgStepper_1011: boolean;
  counter: boolean = false;
  msg100: boolean;
  msg101: boolean;
  play: boolean;
  interval: NodeJS.Timeout;
  timeLeft: number;
  showTimer: boolean;
  timeLeft1: number;
  interval1: NodeJS.Timeout;
  showTimer1: boolean;
  resend_OTP1: boolean;
  isDisabled3: boolean = false;
  msgStepper_1: boolean;
  msgStepper_2: boolean;
  msgStepper_3: boolean;
  showcamploader: boolean;
  inputFormControl: FormControl;
  isDisabled4: boolean = false;
  msgStepper_399: boolean;
  msgStepper_400: boolean;
  isRequestkey: boolean = false;
  tryagain: boolean = false;
  count: number = 0;
  inter: NodeJS.Timeout;
  msgStepper_999: boolean;
  count1: number = 0;
  msgStepper_1000: boolean;
  tryagain1: boolean = false;
  Contact_id: any;
  showerror: boolean = false;
  msgStepper_15: boolean;
  count2: number = 0;
  ContactId: string;
  count3: number = 0;
  ldsloader: boolean;
  LDS_decision1: any;
  showofferLoader: boolean;
  msgStepper_10011: boolean;
  msgStepper_10021: boolean;
  msgStepper_10031: boolean;
  hideldsloader: boolean = false;
  msgStepper_10061: boolean;
  msgStepper_10051: boolean;
  msgStepper_10041: boolean;
  isLDSCompleted1: boolean = false;
  hideofferinterest: boolean = false;
  offerrejection: boolean = false;
  resumejourney: any;
  dedupestatus: any;
  kycstatus: any;
  oppid: any;
  pennydrop: any;
  ldsstatus: string;
  Lid: any;
  mobile: string;
  resumeoffer: boolean;
  resumekyc: boolean;
  msgStepper_rkyc: boolean;
  isContactupdated: any;
  hidesubmit: boolean = false;
  peenydrop: any;
  showmandate: boolean;
  LDSstatus: any;
  disableinterested: boolean = false;
  appid: any;
  resumemandate: boolean;
  r_kyc_flag: string;
  n_kyc_flag: string;
  r_nach_flag: string;
  resume_selfie: boolean;
  kycaddress: boolean = false;
  addressverified: any;
  kyc_button: any;
  kycbutton: any;
  disableform: boolean;
  step1: boolean;
  step2: boolean;
  step3: boolean;
  disablebutton: boolean = false;
  loader4: boolean;
  resumeloader: boolean = false;
  technicalerror: boolean;
  ishiddencom1: boolean = false;
  resumetakeselfie: boolean = false;
  hidenachbutton: boolean = false;
  non_existing_nach: boolean;
  Borrower_Name: any;
  Borrower_Bank_Name: any;
  Borrower_Account_Number: any;
  utmsource: any;
  utmedium: any;
  utmcampgn: any;
  utmcontent: any;
  utmterm: any;
  utmid: any;
  nach_click: any;
  isnachyes: boolean;
  resumenachreject: boolean = false;
  isrejected: boolean = false;
  count_s: number = 0;
  count_n: number = 0;
  Borrower_IFSC: any;
  lafdata: any;
  response: any;
  disablecheckbox: boolean;
  disableldsaccept: boolean;
  session: any;
  sid: string;
  isDisabled5: boolean = false;
  devicedialogopen: boolean;
  latlongresponse: any;
  longitude: any;
  devicelongitude: any;
  devicelatitude: any;
  devicelet: string;
  devicelong: string;
  camp_category: any;
  showTopupOffer: boolean = false;
  sanctionamount: any;
  outstanding: any;
  current_emi: any;
  processing_fee: any;
  topupamount: number;
  disburseamount: number;
  sanctionamount1: string;
  outstanding1: string;
  current_emi1: string;
  processing_fee1: string;
  offerAmount1: string;
  topupamount1: string;
  disburseamount1: string;
  offeremi1: string;
  latest_outstanding: any;
  msgStepper_topup: boolean;
  ishidden3: boolean = false;
  ishidden4: boolean = false;
  rfcFailed: boolean = false;
  isretry: boolean = false;

  private webengage: any;
  accountid: any;
  camp_sub_category: any;
  sourcing_channel: any;
  program_type: any;
  isdetailsconfirmed: boolean = false;
  netdisbusedamount: any;
  insurnace_premium: number;
  insurance_premium: number;
  insurance_flag: any = false;
  insurancedisablecheckbox: boolean = false;
  noinsurance: boolean = false;
  showinsurance: boolean;
  response1: any;
  docurl: any;
  offererror: boolean;
  ErrorMessage: any;
  nachstatus: any;
  curing_status: string;
  curing_emandate: boolean = false;
  dmiCuringWindow: Window;
  checkDmiCuringWindowInterval: NodeJS.Timeout;
  dynamicremandateURL: any;
  curing_journey: boolean = false;
  non_curing_journey: boolean;
  showcuringloader: boolean = false;
  iscuringEMandateCompleted: boolean = false;
  msgStepper_curing_904: boolean = false;
  msgStepper_curing_1010: boolean = false;
  otp_input: boolean = true;
  Request_id: any;
  otperror: any;
  kfsotpverified: boolean = false;
  Errormessage: string;
  istopupcardConfirmed: any;
  topuppromoapplied: boolean;
  topuppromoinvalid: boolean;
  topuppromoattemptleft: boolean;
  topuppromocode1: any;
  topuppromocode: any;
  isSalaried: boolean = false;
  is_Employement_submmited: true;
  msgStepper_10: any;
  employment_type: any;
  transaction_mode: any;
  is_transaction_mode_submitted: boolean;
  is_salary_amount_submitted: boolean;
  msgStepper_001: boolean;
  salary: any;
  Salary_amount: any='';
  msgStepper_002: boolean;
  loan_purspose: any='';
  required_loan: any='';
  required_loan_amount: any='';
  is_loan_purpose: boolean;
  is_loan_amount: boolean;
  msgStepper_003: boolean;
  Xselloffer: boolean = false;
  salary_mode: any='';
  emp_type: any='';
  purspose: any='';
  videourl: any;
  istermsaccepted: boolean=false;
  msgStepper_0001: boolean;
  showHouseholdincome: boolean=false;
  householdincome:any
  isHouseholdincomesubmitted: boolean=false;
  timestamp_terms_acceptance: string;
  filename: string;
  timestamp_download: string;
  ishouseholdgreater: boolean=false;
  msg_1008: boolean;
  showerrormsg: boolean;
  showsalaryerror: boolean;
  processing_fee_withoutgst: any;
  msg: string;
  householdincome1: any;
  netloanamount: any;
  name: any;
  f_name: any;
  l_name: any;
  stp_flag: any;
  pfgst: any;
  prod_structure: any;
  prod_name: any;
  cust_segment: any;
  carry_forward: any;
  camp_type: any;
  insurance_per_day: any;
  nach: boolean;
  insurance_flag1: boolean=false;
  message: string;
  insurance_premium1: any;
  kyc_webengage: boolean;
  constructor(
    private device: DeviceDetectorService,
    private service: HttpRequestService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private modal: NgbModal,
    private stateList: SharedService,
    private dateAdapter: DateAdapter<Date>,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private service1: SenderService,
    private renderer: Renderer2,

    @Inject(DOCUMENT) private document: Document
  ) {
    dateAdapter.setLocale("en-in");
  }

  showSelfieStatus: boolean;
  selfie_Status: string;
  application_id;

  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    

    this.webengage = this.document.defaultView?.webengage;
    //  this.webengage.track("Offer Viewed");
    //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Banner Viewed", {
     "Campaign Type": "",
      "Campaign Category": "",
      "Campaign Sub Category": "",
      "Program Type": "",   
      "Sourcing Channel": "",     
      "Product Structure": "",
      "Product Name": "",
      "Customer Segment": "",
      "Loan Amount": "",   
      "Loan EMI Amount":"",
      "Offer Annualized Interest Rate in %": "",
      "Lead Source":"X-Sell",
      "Purpose of Loan":"",
      "Household Income":"",
      "Mode of Payment":"",
      "Monthly Income":"",      
      "Employment Type":"",
      "Existing KYC Flag": "",
      "Existing Mandate Flag":"",
      "Carry Forward Flag":"",
      "CPV Flag":""

    });

    this.application_id = sessionStorage.getItem("Application_id");

    const body = {
      Request_Key: "",
      Mobile: "",
      Event_Name: "User Visit Page",
      Event_Type: "Page_Visit",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body).subscribe((res) => {});

    this.getQueryParam();
    this.userState = this.stateList.setState();
    this.otpForm = this.formBuilder.group({
      otp: ["", [Validators.required, Validators.maxLength(6)]],
    });
    this.residenceForm = this.formBuilder.group({
      landmark: [""],
      flat: new FormControl("", Validators.required),
      postOffice: new FormControl("", Validators.required),
      District: new FormControl("", Validators.required),
      Pincode: new FormControl("", [Validators.required]),
      State: new FormControl("", Validators.required),
    });
    this.residenceForm1 = this.formBuilder.group({
      landmark: [""],
      flat: ["", Validators.required],
      postOffice: ["", Validators.required],
      District: ["", Validators.required],

      Pincode: new FormControl("", [Validators.required]),
      State: ["", Validators.required],
    });
    this.reasonForm = this.formBuilder.group({
      reason: ["", Validators.required],
    });

    this.monthlyIncome = this.formBuilder.group({
      salary:[''],
      salary_mode:['']
    })
    this.householdIncome = this.formBuilder.group({
      householdincome:['']
    })
  }
  // Function to capture juicy score session id.
  // getsession() {
  //   (<any>window).juicyScoreApi.getSessionId().then((sid: any) => {
  //     this.session = sid;
  //     sessionStorage.setItem("Session ID", this.session);
  //   });
  // }

  hidedivision: boolean = true;
  public forceScrollDown(): void {
    this.ngxAutoScroll.forceScrollDown();
  }
  showOffer: boolean = false;
  // Function to read UTM variables
  getQueryParam() {
    this.activatedRoute.queryParams.subscribe((param) => {
      this.utmsource = param["utm_source"];
      this.utmedium = param["utm_medium"];
      this.utmcampgn = param["utm_campaign"];
      this.utmcontent = param["utm_content"];
      this.utmterm = param["utm_term"];
      if (
        this.utmsource !== undefined ||
        this.utmedium !== undefined ||
        this.utmcampgn !== undefined ||
        this.utmcontent !== undefined ||
        this.utmterm !== undefined
      ) {
        this.hidedivision = false;
        setTimeout(() => {
          this.msgStepper_101 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_102 = true;
        }, 800);
        setTimeout(() => {
          this.msgStepper_103 = true;
        }, 1000);

        const body = {
          utm_source: this.utmsource,
          utm_medium: this.utmedium,
          utm_campaign: this.utmcampgn,
          utm_content: this.utmcontent,
          utm_term: this.utmterm,
          mobile: "",
          id: "",
        };

        this.service.utmservice(body).subscribe((res) => {
          this.utmid = res.Data;
          sessionStorage.setItem("utm_id", this.utmid);
        });
      } else {
        this.hidedivision = false;
        setTimeout(() => {
          this.msgStepper_101 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_102 = true;
        }, 800);
        setTimeout(() => {
          this.msgStepper_103 = true;
        }, 1000);
      }
    });
  }

  get userFormControl() {
    return this.userDetailForm.controls;
  }
  // Verify OTP
  onOtpChange(otp) {
    if (otp.length == 5) {
      let Mobile = sessionStorage.getItem("MobileNumber");

      const body = {
        OTP: otp,
        Mobile: Mobile,
      };

      this.service.getverifyOTP(body).subscribe(
        (res) => {
          this.afterVerifedOTP = true;
          this.otpverified = true;
          const body = {
            Request_Key: "",
            Mobile: sessionStorage.getItem("MobileNumber"),
            Event_Name: "Verify OTP",
            Event_Type: "API",
            Origin: "Frontend",
            Partner_Name: "DMI Finance",
            Remark_1: otp,
            Remark_2: "",
            Remark_3: "",
            Remark_4: "",
            Remark_5: "",
          };

          this.service.getEventTrack(body).subscribe((res) => {});

          this.checkresumejourney();
        },
        (error) => {
          if (error.error.Message.Error) {
            this.wrongOTP = "Please Enter Valid OTP";
            this.showOtpSection = false;

            setTimeout(() => {
              this.showOtpSection = true;
            }, 0);
          }
        }
      );
    }
  }
  // OTP Timer
  startTimer() {
    this.showTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.resend_OTP = true;
        this.showTimer = false;
      } else {
        this.timeLeft = 60;
        this.resend_OTP = false;
      }
    }, 1000);
    this.timeLeft = 60;
    this.showTimer = true;
    this.resend_OTP = false;
  }
  // Automatic City & State patch on Pincode change
  onpinchange(Pincode: any) {
    const body = {
      pincode: Pincode,
    };
    pincode: Pincode;
    this.service.getPincodeDetails(body).subscribe((res) => {
      Validators.maxLength(6);
      Validators.minLength(6);
      this.response=res
      this.CITY = this.response["data"].City;
      this.STATE = this.response["data"].State;
      this.residenceForm1.patchValue({
        District: this.CITY,
        State: this.STATE,
      });
      this.residenceForm.patchValue({
        District: this.CITY,
        State: this.STATE,
      });
    });
  }
  // Resent OTP
  resendOTP() {
    // this.ngOtpInput.setValue();
    this.startTimer();
    const body = {
      Phone: this.User_Mobile,
    };

    this.service.getResendOTP(body).subscribe(
      (res) => {
        const body = {
          Request_Key: "",
          Mobile: this.User_Mobile,
          Event_Name: "OTP Resend",
          Event_Type: "API",
          Origin: "Frontend",
          Partner_Name: "DMI Finance",
          Remark_1: this.User_Mobile,
          Remark_2: "",
          Remark_3: "",
          Remark_4: "",
          Remark_5: "",
        };

        this.service.getEventTrack(body).subscribe((res) => {});
      },
      (error) => {
        if (
          error.error.message.error ==
          "You can't send more than 3 OTP within an hour."
        ) {
          this.wrongOTP = error.error.message.error;
          this.showOtpSection = false;
          setTimeout(() => {
            this.showOtpSection = true;
          }, 0);
        }
      }
    );
  }

  onYes() {
    // this.webengage.track("Offer Loan Journey Initiated");
    this.isYes = true;
    this.hidebutton = !this.hidebutton;
    setTimeout(() => {
      this.msgStepper_104 = true;
    }, 500);
    setTimeout(() => {
      this.msgStepper_105 = true;
    }, 1300);
    setTimeout(() => {
      this.msgStepper_106 = true;
    }, 2100);
    setTimeout(() => {
      this.msgStepper_107 = true;
    }, 2900);

    const body = {
      Request_Key: "",
      Mobile: sessionStorage.getItem("Mobile"),
      Event_Name: "Yes Button Clicked",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body).subscribe((res) => {});
  }

  isNo: boolean = false;
  onNoClick() {
    this.hidebutton = !this.hidebutton;
    this.isNo = true;
    setTimeout(() => {
      this.msgStepper_108 = true;
    }, 500);
    setTimeout(() => {
      this.msgStepper_109 = true;
    }, 1300);
    const body = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "No Button Clicked",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body).subscribe((res) => {});
  }
  sfdcMobile: boolean;
  sfdcresult: any;
  res_status: any;
  sfdcUserName: any;
  User_Mobile: any;
  userNotFound: any;
  matchMob: any;
  msg_10: boolean;
  msg_13: boolean;
  msg_12: boolean;
  otpverified: boolean;
  camp_details: any;
  offernumber1: boolean = false;
  offernumber2: boolean = false;
  wrongMobile: boolean = false;
  resend_OTP: boolean = true;
  disableinput: boolean = false;
  promocode: any;
  promocode1: any;
  Discounted_PF: any;
  promoapplicable: boolean = true;

  onSubmitMobile(event) {
  
    if (event == 1) {
      let stringMob = this.mobileNumber.toString();
      sessionStorage.setItem("MobileNumber", this.mobileNumber.toString());

      const body = {
        Request_Key: "",
        Mobile: stringMob,
        Event_Name: "Clicked Continue Button",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };
      this.service.getEventTrack(body).subscribe((res) => {});
      if (stringMob.length < 10 || stringMob.length > 10) {
        this.wrongMobile = true;
        this.isYes1 = false;
      }
      if (stringMob.length === 10) {
        this.disableinput = true;
        this.showLoader = true;
        this.wrongMobile = false;
        this.isYes1 = true;
        this.utmid = sessionStorage.getItem("utm_id");
        if (this.utmid != null) {
          const body = {
            utm_source: this.utmsource,
            utm_medium: this.utmedium,
            utm_campaign: this.utmcampgn,
            utm_content: this.utmcontent,
            utm_term: this.utmterm,
            mobile: stringMob,
            id: this.utmid,
          };

          this.service.utmservice(body).subscribe((res) => {
            this.utmid = res.Data;
            sessionStorage.setItem("utm_id", this.utmid);
          });
        }

        const body = {
          Mobile: stringMob,
          Request_Key: "",
        };
        this.service.getcampaignInfo(body).subscribe((res) => {
          this.showLoader = false;
          // this.deviceTrack();
          this.response=res

          this.camp_Status = this.response.Status;
          this.camp_details = this.response["Data"];
          if (
            this.camp_details === "Sorry! Your loan offer has been expired."
          ) {
            this.offernumber1 = false;
            this.offernumber2 = true;
          }

          if (this.camp_details == "Sorry! No loan offer available for you.") {
            this.hideSection = true;
            setTimeout(() => {
              this.msgStepper_108 = true;
            }, 1500);
            setTimeout(() => {
              this.msgStepper_109 = true;
            }, 1500);
            setTimeout(() => {
              this.msgStepper_113 = true;
            }, 3500);
          } else {
    
            sessionStorage.setItem(
              "Mobile",
              this.camp_details[0].Borrowers_Mobile_Number__c
            );
            sessionStorage.setItem("Campaign_Id", this.camp_details[0].Id);
            sessionStorage.setItem(
              "Customer_Name",
              this.camp_details[0].First_Name__c
            );
            sessionStorage.setItem(
              "Status",
              this.camp_details[0].Stage_Of_Campaign__c
            );
            sessionStorage.setItem(
              "kyc_flag",
              this.camp_details[0].Existing_KYC_Use_Flag__c
            );
            sessionStorage.setItem(
              "nach_flag",
              this.camp_details[0].NACH_flag__c
            );
            sessionStorage.setItem(
              "Offer_Amount",
              this.camp_details[0].Offered_Amount__c
            );
            sessionStorage.setItem(
              "Offer_Tenor",
              this.camp_details[0].Offered_Tenor__c
            );
            sessionStorage.setItem(
              "Offer_Roi",
              this.camp_details[0].Offered_ROI__c
            );
            sessionStorage.setItem(
              "ROI_Annually",
              this.camp_details[0].ROI_Annually
            );
            sessionStorage.setItem(
              "otp_flag",
              this.camp_details[0].OTP_Generation_NotRequired__c

            );
            sessionStorage.setItem("offer_emi", this.camp_details[0].EMI__c);
            sessionStorage.setItem(
              "existingloan",
              this.camp_details[0].Existing_Personal_Loan
            );
            sessionStorage.setItem(
              "currentoutstanding",
              this.camp_details[0].Current_Outstanding
            );
            sessionStorage.setItem(
              "currentemi",
              this.camp_details[0].Current_EMI
            );
            sessionStorage.setItem(
              "com_add_flag",
              this.camp_details[0].Existing_Communication_Address_Use_Flag__c
            );
            sessionStorage.setItem("Offer Grid", this.camp_details[0].Details);
            // console.log(this.camp_details[0].Details);
            this.accountid = this.camp_details[0].AccountId__c;
            // console.log(this.accountid,"accountid")
            this.camp_sub_category =
              this.camp_details[0].Campaign_Sub_Category__c;
            this.sourcing_channel = this.camp_details[0].Sourcing_Channel__c;
            this.program_type = this.camp_details[0].Program_Type__c;
            this.videourl = this.camp_details[0].Loan_Process_Video;
            // console.log( this.videourl,'url')
            // console.log(this.camp_details[0].Id,'campaignid')
            this.camp_category = this.camp_details[0].Campaign_Category__c;
            //  this.insurance_premium=this.camp_details[0].Insurance_Premium__c
            // this.insurance_premium1=500
             this.insurance_flag = this.camp_details[0].Insurance_Offered__c;
          //  this.insurance_flag=false
            //  console.log(this.insurance_premium,this.insurance_flag)
            // 
            // Stp flag 
            this.stp_flag = this.camp_details[0].STP_Flag__c;
            if( this.stp_flag=='CPV Required')
            {
              this.message='With CPV'
            }
            else{
              this.message='Without CPV'
            }
            this.prod_structure= this.camp_details[0].Product_Structure__c?? ""
            this.prod_name= this.camp_details[0].Product_Name__c?? ""
            this.cust_segment= this.camp_details[0].Customer_Segment__c?? ""
            this.camp_type=this.camp_details[0]. Campaign_Type__c?? ""
            this.carry_forward= this.camp_details[0].Carry_Forward__c ?? ""          
            if (
              this.accountid == null ||
              this.accountid == "" ||
              this.accountid == undefined
            ) {
              this.webengage.user.login(this.camp_details[0].UserId__c);
              this.webengage.user.setAttribute("Account ID present", false);
            } else {
              this.webengage.user.login(this.accountid);
              this.webengage.user.setAttribute("Account ID present", true);
            }

            // ABND INSURANCE

            this.sanctionamount = this.camp_details[0].Existing_Personal_Loan;
            this.sanctionamount1 = Intl.NumberFormat("en-IN").format(
              this.sanctionamount
            );
            this.outstanding = this.camp_details[0].Current_Outstanding;
            this.outstanding1 = Intl.NumberFormat("en-IN").format(
              this.outstanding
            );
            this.current_emi = this.camp_details[0].Current_EMI;
            this.current_emi1 = Intl.NumberFormat("en-IN").format(
              this.current_emi
            );
            this.processing_fee = this.camp_details[0].Processing_Fees_GST__c;
            this.processing_fee_withoutgst=this.camp_details[0].Processing_Fee__c
            // this.processing_fee1 = Intl.NumberFormat("en-IN").format(
            //   this.processing_fee
            // );
            // console.log(this.processing_fee1,'pf')
            this.f_name= this.camp_details[0].First_Name__c==null?"":this.camp_details[0].First_Name__c;
            this.l_name= this.camp_details[0].Last_Name__c==null?"":this.camp_details[0].Last_Name__c
            this.User_Mobile = sessionStorage.getItem("Mobile");
            this.userName = sessionStorage.getItem("Customer_Name");            
            this.userStatus = sessionStorage.getItem("Status");
            this.user_Email = sessionStorage.getItem("email");
             this.otp_flag = sessionStorage.getItem("otp_flag");
            // this.otp_flag='false';
            this.offerAmount = sessionStorage.getItem("Offer_Amount");
            this.offerAmount1 = Intl.NumberFormat("en-IN").format(
              this.offerAmount
            );
            this.offertenor = sessionStorage.getItem("Offer_Tenor");
            this.offerroi = sessionStorage.getItem("Offer_Roi");
            this.ROIAnnually = sessionStorage.getItem("ROI_Annually");
            this.offeremi = sessionStorage.getItem("offer_emi");
            this.offeremi1 = Intl.NumberFormat("en-IN").format(this.offeremi);
            this.matchMob = this.mobileNumber.toString();
            this.kyc_flag_status = sessionStorage.getItem("kyc_flag");
            if( this.kyc_flag_status == 'false')
            {
              this.kyc_webengage=false
            }
            else{
    this.kyc_webengage=true
            }
            this.nach_flag = sessionStorage.getItem("nach_flag");
            if(this.nach_flag=='0')
            {
              this.nach=false;
            }
            else{
              this.nach=true
            }
             
            
            this.topupamount = this.offerAmount - this.outstanding;           
            this.topupamount1 = Intl.NumberFormat("en-IN").format(
              this.topupamount
            );
           
            this.processingFeePercentage = this.camp_details[0].PF_Value__c;
            
            if (this.camp_category == "X-Sell") {
             
              this.min = this.camp_details[0].Details.OfferGrid[0].min_amount;
              this.max =
                this.camp_details[0].Details.OfferGrid[
                  this.camp_details[0].Details.OfferGrid.length - 1
                ].max_amount;
              this.gridsize = this.max;
              this.updateSetting(this.gridsize);
            }

            if (
              (this.insurance_flag == "true" || this.insurance_flag == true) &&
              this.camp_category == "X-Sell"
            ) {
              this.showinsurance = true;
               this.promoapplicable =this.camp_details[0].Discount_Coupons_Offered__c;
              // this.promoapplicable=false;
              //  this.insurance_opted=false
              // this.netdisbusedamount=this.GridAmount-this.GridProcessingFee;
              // const body={
              //   Application_Id: sessionStorage.getItem("Application_id")
              // }
              // this.service.insurancedoc(body).subscribe(res=>{
              //   this.docurl=res.Data

              // }
              //   )
            } else if (this.camp_category == "Top-Up") {              
               this.promoapplicable =this.camp_details[0].Discount_Coupons_Offered__c;  
                //  this.promoapplicable=false;
                              // console.log(this.promoapplicable, "promo");             
            } else {
              this.showinsurance = false;
              // this.netdisbusedamount=this.offerAmount-this.processing_fee;
            }
            if (this.kyc_flag_status == "true") {
              this.kyc_flag = true;
            } else {
              this.kyc_flag = false;
            }
            if ((this.nach_flag = "0")) {
              this.nach_flag_status = true;
            } else {
              this.nach_flag_status = false;
            }
          }
          if (this.userStatus == "Available" && this.otp_flag == "true") {
           

            this.curing_journey = true;
            this.disableinput = true;
            this.otpverified = true;
            this.otpOption = false;
            this.afterVerifedOTP = true;
            setTimeout(() => {
              this.msgStepper_80 = true;
            }, 1000);
            this.isSalaried = false;
            //

            this.checkresumejourney();

            // this.deviceTrack();
            if (this.camp_category == "Top-Up") {
              this.calculatePF(this.topupamount,this.processingFeePercentage);            
              this.showTopupOffer = true;
            
            } else {
              this.showTopupOffer = false;
              // this.Xselloffer = true;
              // this.netdisbusedamount=this.offerAmount-this.processing_fee- this.insurance_premium
              // console.log(this.netdisbusedamount)
            }
          }
 
          if (this.userStatus == "Available" && this.otp_flag == "false") {
      
            this.curing_journey = true;
            this.disableinput = true;
            this.otpOption = true;
            this.hideSection = false;
            this.isSalaried = false;
         

            if (this.camp_category == "Top-Up") {
              this.showTopupOffer = true;
            } else {
              this.showTopupOffer = false;
            }

            this.startTimer();
            this.resend_OTP = false;

            const body = {
              Phone: this.User_Mobile,
            };
            this.service.sendOTP(body).subscribe(
              (res) => {
                this.routerKey = res;
                const body = {
                  Request_Key: "",
                  Mobile: stringMob,
                  Event_Name: "OTP Send",
                  Event_Type: "API",
                  Origin: "Frontend",
                  Partner_Name: "DMI Finance",
                  Remark_1: "",
                  Remark_2: "",
                  Remark_3: "",
                  Remark_4: "",
                  Remark_5: "",
                };

                this.service.getEventTrack(body).subscribe((res) => {});
              },
              (error) => {
                this.isDisabled = false;
              }
            );
          }
           //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Loan Journey Initiated", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": parseInt(this.offerAmount)??"",    
      "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
      "Existing KYC Flag": (this.kyc_webengage)??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
        });
      }
    }
   
  }

  promoapplied: boolean = false;
  promoinvalid: boolean = false;
  promoattemptleft: boolean = false;
  PF_after_promo: any;
  buttondisabled: boolean = true;
  Repromoapplicable: boolean = true;
  onSubmitPromo() {
    this.promoapplied=false;
    const body = {
      Application_Id: this.Application_id,
      Coupon_Name: this.promocode,
    };
    this.service.applypromocode(body).subscribe({
      next: (res) => {
        this.buttondisabled = false;
        this.response=res
        // this.promocode = '';
        if (
          this.response.Status == 200 &&
          this.promoapplicable == true &&
          this.response.Message != "Promo code invalid! You have 0 attempts left."
        ) {
          // console.log(res.Data);
          this.Repromoapplicable = false;
          this.promoapplied = true;
          this.Discounted_PF =   this.response.Data.principle_discount_amount;
          this.PF_after_promo =   this.response.Data.new_processing_fees;
        } else if (
          this.response.Message == "Promo code invalid! You have 0 attempts left."
        ) {
          this.promoattemptleft = true;
        }
      },
      error: err =>{
        this.buttondisabled = false;
        this.promoinvalid = true;
        // this.promocode = ''
        //  if(err.status == 404){
        //   this.promoinvalid = true;
        // }
      }
    });
  }

  onSubmitPromo1() {
    const body = {
      Application_Id: this.Application_id,
      Coupon_Name: this.promocode1,
    };
    this.service.applypromocode(body).subscribe({
      next: (res) => {
        this.buttondisabled = false;
        // this.promocode1 = '';
        if (
          this.response.Status == 200 &&
          this.promoapplicable == true &&
          this.response.Message != "Promo code invalid! You have 0 attempts left."
        ) {
          // console.log(res.Data);
          this.Repromoapplicable = false;
          this.promoapplied = true;
          this.Discounted_PF =   this.response.Data.principle_discount_amount;
          this.PF_after_promo =   this.response.Data.new_processing_fees;
          this.promocode = "";
        } else if (
          this.response.Message == "Promo code invalid! You have 0 attempts left."
        ) {
          this.promoattemptleft = true;
        }
      },
      error: err =>{
        this.buttondisabled = false;
        this.promoinvalid = true;
        this.promocode = this.promocode1
        this.promocode1 = ''
        //  if(err.status == 404){
        //   this.promoinvalid = true;
        // }
      },
    });
  }

  applydisable: boolean = false;
  applydisable1: boolean = false;
  // Topuppromo
  onSubmitTopupPromo() {
    // this.topuppromoattemptleft = true
    if (this.promocode == "") {
      this.topuppromoapplied = true;
    } else {
      const body = {
        Application_Id: this.Application_id,
        Coupon_Name: this.topuppromocode,
      };
      this.service.applypromocode(body).subscribe({
        next: (res) => {
          this.response=res
          this.applydisable = true;
          // this.promocode = '';
          if (
            this.response.Status == 200 &&
            this.promoapplicable == true &&
            this.response.Message != "Promo code invalid! You have 0 attempts left."
          ) {
            // console.log(res.Data);
            this.Repromoapplicable = false;
            this.topuppromoapplied = true;
            this.Discounted_PF =   this.response.Data.principle_discount_amount;
            this.PF_after_promo =   this.response.Data.new_processing_fees;
            this.disburseamount = this.topupamount - this.PF_after_promo;
            this.disburseamount1 = Intl.NumberFormat("en-IN").format(
              this.disburseamount
            );
          } else if (
            this.response.Message == "Promo code invalid! You have 0 attempts left."
          ) {
            this.topuppromoattemptleft = true;
          }
        },
        error: (err) => {
          // this.buttondisabled = false;
          // this.topuppromoapplied=true;
          this.topuppromoinvalid = true;
          this.promocode = "";
          this.promocode = this.applydisable = true;
          //  if(err.status == 404){
          //   this.promoinvalid = true;
          // }
        },
      });
    }
  }
  onSubmitTopupPromo1() {
    // this.topuppromoattemptleft = true
    this.topuppromoinvalid = false;
    this.topuppromocode = this.topuppromocode1;
    const body = {
      Application_Id: this.Application_id,
      Coupon_Name: this.topuppromocode,
    };
    this.service.applypromocode(body).subscribe({
      next: (res) => {
        this.response=res
        // this.promocode = '';
        if (
          this.response.Status == 200 &&
          this.promoapplicable == true &&
          this.response.Message != "Promo code invalid! You have 0 attempts left."
        ) {
          // console.log(res.Data);
          this.applydisable1 = true;
          this.topuppromoapplied = true;
          this.Discounted_PF =   this.response.Data.principle_discount_amount;
          this.PF_after_promo =   this.response.Data.new_processing_fees;
          this.disburseamount = this.topupamount - this.PF_after_promo;
          this.disburseamount1 = Intl.NumberFormat("en-IN").format(
            this.disburseamount
          );
        } else if (
          this.response.Message == "Promo code invalid! You have 0 attempts left."
        ) {
          this.topuppromoattemptleft = true;
          this.applydisable1 = true;
          this.topuppromoapplied = false;
          this.promoapplicable = false;
        }
      },
      error: (err) => {
        // this.buttondisabled = false;
        // this.topuppromoapplied=true;
        this.topuppromoinvalid = true;
        this.topuppromoapplied = false;
        this.promocode = "";
        this.applydisable = true;
        //  if(err.status == 404){
        //   this.promoinvalid = true;
        // }
      },
    });
  }

  ishiddencom: boolean = false;
  iscommupdated: boolean = false;
  ishidden5: boolean = false;
  ishidden6: boolean = false;
  flat1: any;
  street: any;
  district: any;
  state: any;
  pincode: any;

  wrongMobile1: boolean = false;
  disableinput1: boolean = false;
  onUpdateAddress1(form: any) {
    if (form.invalid) {
      form.controls.landmark.touched = true;
      form.controls.postOffice.touched = true;
      form.controls.flat.touched = true;
      form.controls.District.touched = true;
      form.controls.State.touched = true;
      form.controls.Pincode.touched = true;
      return;
    }
       this.loader3 = true;
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Update Address",
      Event_Type: "API",
      Origin: "Button",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});

    this.ishiddencom = !this.ishiddencom;

    this.landmark = this.residenceForm1.get("landmark").value;
    this.postOffice = this.residenceForm1.get("postOffice").value;
    this.street = this.residenceForm1.get("flat").value;
    this.district = this.residenceForm1.get("District").value;
    this.state = this.residenceForm1.get("State").value;
    this.pincode = this.residenceForm1.get("Pincode").value;
    const body = {
      Campaign__c: sessionStorage.getItem("Campaign_Id"),
      Landmark: this.landmark,
      Post_Office: this.postOffice,
      MobilePhone: this.User_Mobile,
      Street: this.street,
      City: this.district,
      State: this.state,
      PostalCode: this.pincode,
    };
    this.service.updateaddresinfo(body).subscribe((res) => {
      if (res.Status == 200) {
        this.iscommupdated1 = true;
        this.disableinput1 = true;
        this.loader3 = false;
        this.wrongMobile1 = false;

        const body = {
          Request_Key: "",
          Mobile: this.User_Mobile,
          Event_Name: "Update Address",
          Event_Type: "API",
          Origin: "Frontend",
          Partner_Name: "DMI Finance",
          Remark_1: "",
          Remark_2: "",
          Remark_3: "",
          Remark_4: "",
          Remark_5: "",
        };

        this.service.getEventTrack(body).subscribe((res) => {});

        setTimeout(() => {
          this.msg20 = true;
        }, 500);
        setTimeout(() => {
          this.msg21 = true;
        }, 800);
        setTimeout(() => {
          this.msg22 = true;
        }, 2000);
        setTimeout(() => {
          this.msg23 = true;
        }, 2500);
      } else if (res.Status == 422) {
        this.iscommupdated1 = false;
        this.ishiddencom = false;
        this.loader3 = false;
        this.wrongMobile1 = true;
        this.requiredMsg = "Please enter valid Pincode.";
      }
    });
  }
  hideaddress: boolean = false;
  isrepeateKyc: boolean = false;
  repeatekyc() {
   
    this.hideaddress = !this.hideaddress;
    const body = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "KYC No Button Clicked",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body).subscribe((res) => {});
    this.isrepeateKyc = true;
    setTimeout(() => {
      this.msgStepper_30 = true;
    }, 500);
    setTimeout(() => {
      this.msgStepper_31 = true;
    }, 1000);
    setTimeout(() => {
      this.msgStepper_32 = true;
    }, 1200);
  }

  addressrequired: boolean = false;
  checkadressflag() {
    this.hideaddress = !this.hideaddress;

     //Richa Pathak
    //18/03/2025
  
      this.webengage.track("KYC Verification Initiated" , {
        "Campaign Type": this.camp_type??"",
        "Campaign Category": this.camp_category??"",
        "Campaign Sub Category": this.camp_sub_category??"",
        "Program Type": this.program_type??"",   
        "Sourcing Channel": this.sourcing_channel??"",     
        "Product Structure": this.prod_structure??"",
        "Product Name": this.prod_name??"",
        "Customer Segment": this.cust_segment??"",
        "Loan Amount": parseInt(this.GridAmount)??"",   
        "Loan EMI Amount":parseInt(this.GridEmi)??"",
        "Loan Annualized Interest Rate in %": this.ROIAnnually??"",
        "Lead Source":"X-Sell",
       "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
        "Household Income":this.householdincome1??"",
        "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
        "Monthly Income":parseInt(this.Salary_amount||this.salary)??""  ,      
        "Employment Type":(this.emp_type||this.employment_type)??"",
        "Udhyam Registered":"",
        "KYC Type":"Digilocker/EKYC",      
        "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
        "Carry Forward Flag":this.carry_forward??"",
        "CPV Flag":this.stp_flag??""     
    });

    const body = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "KYC Yes Button Clicked",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body).subscribe((res) => {});
    this.comnadress = sessionStorage.getItem("com_add_flag");

    if (this.comnadress == "false") {
      this.addressrequired = true;
      setTimeout(() => {
        this.msgStepper_33 = true;
      }, 500);
    } else {
      this.addressrequired = false;
      setTimeout(() => {
        this.msgStepper_34 = true;
      }, 1000);
      setTimeout(() => {
        this.msgStepper_50 = true;
      }, 1500);
    }
  }
  isSameAddress: boolean = false;
  sameAddress() {   
    this.hidebutton1 = !this.hidebutton1;
    this.isSameAddress = true;
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Address Verify Yes Button",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body1).subscribe((res) => {});

    const body = {
      Campaign__c: sessionStorage.getItem("Campaign_Id"),
      Landmark: "",
      Post_Office: "",
      MobilePhone: this.User_Mobile,
      Street: sessionStorage.getItem("MailingStreet"),
      City: sessionStorage.getItem("MailingCity"),
      State: sessionStorage.getItem("MailingState"),
      PostalCode: sessionStorage.getItem("MailingPostalCode"),
    };
    this.service.updateaddresinfo(body).subscribe((res) => {});
    setTimeout(() => {
      this.msgStepper_35 = true;
    }, 800);
    setTimeout(() => {
      this.msgStepper_36 = true;
    }, 1000);
  }
  notsameAddress() {
    this.hidebutton1 = !this.hidebutton1;
    this.isnotSameAddress = true;

    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Address Verify No Button",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});
    setTimeout(() => {
      this.msgStepper_37 = true;
    }, 800);
    setTimeout(() => {
      this.msgStepper_38 = true;
    }, 1000);
  }
  existingnach() {
    this.webengage.track("e-Mandate Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": this.offerAmount??"",   
      "Loan EMI Amount":this.offeremi??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":this.showinsurance??""

    });
    if (this.nach_flag_status == false) {
      this.hidenachbutton = true;
      this.loader4 = true;
      this.isnachyes = true;

      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Nach Yes Button Clicked",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };
      this.service.getEventTrack(body1).subscribe((res) => {});

      const body = {
        Mobile: sessionStorage.getItem("Mobile"),
      };
      this.service.exisiting_nach(body).subscribe(
        (res) => {
          if (this.isSelfie == false) {
            this.checknachcallbackstatus3();
          } else {
            this.checkselfiecallbackstatus3();
          }

          if (this.camp_category == "Top-Up") {
            this.get_Existing_Loan();
          }
        },
        (error) => {
          this.technicalerror = true;
          this.loader4 = false;
        }
      );
    }
  }
  nonexistingnach() {
    this.isnachyes = false;
      const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Nach No Button Clicked",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});
    this.non_existing_nach = true;
    this.isDisabled2 = false;

    this.hidenachbutton = true;
  }

  checkselfiecallbackstatus3() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.callback(body).subscribe(
      (res) => {
        this.mandate_decision = res["Data"];

        if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Opportunity_Id != "" &&
          this.mandate_decision.Ready_For_Conversion == "Success" &&
          (this.mandate_decision.NACH_Status == "success" ||
            this.mandate_decision.NACH_Status == "Success")
        ) {
          this.loader4 = false;        
          this.isEMandateCompleted = true;        
          this.webengage.track("KFS Viewed", {
            "Campaign Type": this.camp_type??"",
            "Campaign Category": this.camp_category??"",
            "Campaign Sub Category": this.camp_sub_category??"",
            "Program Type": this.program_type??"",   
            "Sourcing Channel": this.sourcing_channel??"",     
            "Product Structure": this.prod_structure??"",
            "Product Name": this.prod_name??"",
            "Customer Segment": this.cust_segment??"",
            "Loan Amount":(this.GridAmount)?.toString()??"",
            "Loan EMI Amount":(this.GridEmi)?.toString()??"",
            "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
            "Lead Source":"X-Sell",
           "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
            "Household Income":this.householdincome1?.toString()||"",
            "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
            "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
            "Employment Type":(this.emp_type||this.employment_type)??"",
            "Existing KYC Flag": this.kyc_webengage??"",
             "Existing Mandate Flag":this.nach??"",
            "Carry Forward Flag":this.carry_forward??"",
            "Insurance Amount":(this.insurance_premium1)??"",
             "CPV Flag":this.stp_flag??"",
            "Insurance Flag":this.insurance_flag1??""
      
          });
          this.KFS_otp_send();
          
          setTimeout(() => {
            this.msgStepper_904 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_topup = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10011 = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10021 = true;
          }, 600);
          setTimeout(() => {
            this.msgStepper_10031 = true;
          }, 650);
          clearInterval(this.checkDmiKYCWindowInterval);
        } else if (this.mandate_decision.NACH_Status == "Failure") {
          this.isEMandateCompleted = false;
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isDisabled2 = false;
          setTimeout(() => {
            this.msgStepper_999 = true;
          }, 500);
        } else if (this.mandate_decision.Penny_Drop_Decision == "REJECTED") {
          this.isEMandateCompleted = false;
          this.loader4 = false;
          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else if (
          this.mandate_decision.NACH_Status == "REJECTED" ||
          this.mandate_decision.NACH_Status == "Rejected"
        ) {
          this.isEMandateCompleted = false;
          this.loader4 = false;
          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Ready_For_Conversion == "Failed"
        ) {
          this.isEMandateCompleted = false;

          this.loader4 = false;
          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else {
          this.count_s += 1;
          if (this.count_s <= 1500) {
            setTimeout(() => {
              this.checkselfiecallbackstatus3();
            }, 4000);
          } else {
            const body1 = {
              Request_Key: "",
              Mobile: this.User_Mobile,
              Event_Name: "Technical Error - Penny-Drop callback not received",
              Event_Type: "Button",
              Origin: "Frontend",
              Partner_Name: "DMI Finance",
              Remark_1: "",
              Remark_2: "",
              Remark_3: "",
              Remark_4: "",
              Remark_5: "",
            };

            this.service.getEventTrack(body1).subscribe((res) => {});
            this.isEMandateCompleted = false;
            this.tryagain = true;
            clearInterval(this.checkDmiKYCWindowInterval);

            setTimeout(() => {
              this.msgStepper_999 = true;
            }, 500);
            this.count_s = 0;
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkselfiecallbackstatus3();
        }, 5000);

        return;
      }
    );
  }
  takeSelefie() {   
    this.isSelfie = false;
    this.hidebutton2 = !this.hidebutton2;
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Proceed For Selfie",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});
    const modalref1 = this.modal.open(SdDreamCamComponent, {
      backdrop: "static",
      centered: true,
      size: "lg",
      windowClass: "termsModal",
      keyboard: false,
    });

    modalref1.componentInstance.SelfieStatus.subscribe((res) => {
      if (res.status == "Success") {
        this.isSelfie = true;
        this.isretry = false;
        setTimeout(() => {
          this.msgStepper_39 = true;
        }, 1500);
      } else if (res.status == "Retry") {
        this.isretry = true;
        this.isSelfie = false;
        this.hidebutton2 = false;
      } else if (res.status == "Fail") {
        this.isSelfie = false;
        setTimeout(() => {
          this.msgStepper_399 = true;
        }, 800);
        setTimeout(() => {
          this.msgStepper_400 = true;
        }, 1000);
      }
    });
  }
  pincode1;
  Pincode2: string;
  CITY;
  STATE;
  pin: string;

  ismandaterequired: boolean = true;
  showLDS: boolean = false;
  onUpdateAddress(form: any) {
    if (form.invalid) {
      form.controls.landmark.touched = true;
      form.controls.postOffice.touched = true;
      return;
    }
     //Richa Pathak
    //18/03/2025
    this.webengage.track("Confirmed Address Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": (this.GridAmount)?.toString()??"",   
      "Loan EMI Amount":(this.GridEmi)?.toString()??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1)?.toString()??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
    this.ishiddencom = !this.ishiddencom;
    this.landmark = this.residenceForm.get("landmark").value;
    this.postOffice = this.residenceForm.get("postOffice").value;
    this.street = this.residenceForm.get("flat").value;
    this.district = this.residenceForm.get("District").value;
    this.state = this.residenceForm.get("State").value;
    this.pincode = this.residenceForm.get("Pincode").value;
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Update Address",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body1).subscribe((res) => {});

    const body = {
      Campaign__c: sessionStorage.getItem("Campaign_Id"),
      Landmark: this.landmark,
      Post_Office: this.postOffice,
      MobilePhone: this.User_Mobile,
      Street: this.street,
      City: this.district,
      State: this.state,
      PostalCode: this.pincode,
    };
    this.service.updateaddresinfo(body).subscribe((res) => {
      if (res.Status == 200) {
        this.iscommupdated = true;
        this.wrongMobile1 = false;

        setTimeout(() => {
          this.msg20 = true;
        }, 500);
        setTimeout(() => {
          this.msg21 = true;
        }, 800);
        setTimeout(() => {
          this.msg22 = true;
        }, 2000);
      } else if (res.Status == 422) {
        this.iscommupdated = false;
        this.ishiddencom = false;
        this.wrongMobile1 = true;
        this.requiredMsg = "Please enter valid Pincode.";
      }
    });
  }
  loader2: boolean;
  msg5: boolean;
  msg6: boolean;
  ishidden: boolean = false;
  DedupeStatus;

  checkcalllback() {
    const timeOuts = [3000, 5000, 5000];
    let apiCounter = 0;

    setTimeout(() => {
      const body = {
        Mobile: this.User_Mobile,
      };
      this.service.callback(body).subscribe((res) => {
        this.leadcreated = res.Data.Lead_Id;
        this.Contact_id = res.Data.Contact_Id;

        sessionStorage.setItem("Contact_id", this.Contact_id);
        this.DedupeStatus = res.Data.Dedupe_Status;
        if (this.leadcreated != "" || this.leadcreated != null) {
          if (this.DedupeStatus == "Pre Approved") {
            this.showLoader1 = false;
            this.tryagain1 = false;

            const body = {
              Campaign_ID: sessionStorage.getItem("Campaign_Id"),
              Session_ID: sessionStorage.getItem("Session ID"),
            };

            gtag("event", "Application load", {
              value: "replace with value",
              items: [
                {
                  id: "replace with value",
                  location_id: "replace with value",
                  google_business_vertical: "custom",
                },
              ],
            });
          } else if (
            this.DedupeStatus == "Rejected" ||
            this.DedupeStatus == "Failed"
          ) {
            this.counter = true;
            setTimeout(() => {
              this.msg100 = true;
            }, 500);
            setTimeout(() => {
              this.msg101 = true;
            }, 800);
            this.showLoader1 = false;
            this.tryagain1 = false;
            return;
          } else {
            this.count2 += 1;

            if (this.count2 <= 1500) {
              setTimeout(() => {
                this.checkcalllback();
              }, 1000);
            } else {
              const body1 = {
                Request_Key: "",
                Mobile: sessionStorage.getItem("Mobile"),
                Event_Name: "Technical Error - Dedupe callback not received",
                Event_Type: "Button",
                Origin: "Frontend",
                Partner_Name: "DMI Finance",
                Remark_1: "",
                Remark_2: "",
                Remark_3: "",
                Remark_4: "",
                Remark_5: "",
              };
              this.service.getEventTrack(body1).subscribe((res) => {});
              this.tryagain1 = true;
              this.showLoader1 = false;

              setTimeout(() => {
                this.msgStepper_1000 = true;
              }, 500);
              this.count2 = 0;
            }
          }
        }
      });
    }, 9000);
  }

  i: any;
  j: any;
  min: any;
  gridsize: any;
  max: any;

  selectedEMI: any;
  selectedTenure: any;
  offeredInterest: any;
  interestRate: any;

  tenorOptions: any;
  emi: any;
  rateOfInterest: any;
  selectedId: any = -1;
  interest: any;
  stepup: any;
  processingFeePercentage: any;
  processingFeeValue: any;

  updateSetting(event) {
    this.gridsize = Number(event);
    // console.log(this.gridsize,'gridsize')

    this.j = this.camp_details[0].Details.OfferGrid.length - 1;
    for (this.j; this.j >= 0; this.j--) {
      if (
        this.gridsize >=
          this.camp_details[0].Details.OfferGrid[this.j].min_amount &&
        this.gridsize <=
          this.camp_details[0].Details.OfferGrid[this.j].max_amount
      ) {
        this.tenorOptionFunction(this.j);
        this.stepup =
          this.camp_details[0].Details.OfferGrid[this.j].loan_amount_step_up;
      }
    }
  }

  tenorOptionFunction(index) {
    this.tenorOptions = [];
    this.emi = [];
    this.interest = [];
    this.rateOfInterest = [];
    let counter = 0;
    for (
      this.i = 0;
      this.i <=
      (parseInt(this.camp_details[0].Details.OfferGrid[index].max_tenor) -
        parseInt(this.camp_details[0].Details.OfferGrid[index].min_tenor)) /
        parseInt(this.camp_details[0].Details.OfferGrid[index].stepup_tenor);
      this.i++
    ) {
      this.tenorOptions[counter] =
        parseInt(this.camp_details[0].Details.OfferGrid[index].min_tenor) +
        parseInt(this.camp_details[0].Details.OfferGrid[index].stepup_tenor) *
          this.i;
      this.emi[counter] = (
        (this.gridsize *
          (this.camp_details[0].Details.OfferGrid[index].roi /
            100 /
            12) *
          Math.pow(
            1 +
              this.camp_details[0].Details.OfferGrid[index].roi /
                100 /
                12,
            this.tenorOptions[counter]
          )) /
        (Math.pow(
          1 +
            this.camp_details[0].Details.OfferGrid[index].roi /
              100 /
              12,
          this.tenorOptions[counter]
        ) -
          1)
      ).toFixed(2);
      this.interest[counter] = (
        (this.emi[counter] * this.tenorOptions[counter] - this.gridsize) /
        this.tenorOptions[counter]
      ).toFixed(2);
      this.emi[counter] = Math.round(
        (this.gridsize *
          (this.camp_details[0].Details.OfferGrid[index].roi/
            100 /
            12) *
          Math.pow(
            1 +
              this.camp_details[0].Details.OfferGrid[index].roi /
                100 /
                12,
            this.tenorOptions[counter]
          )) /
          (Math.pow(
            1 +
              this.camp_details[0].Details.OfferGrid[index].roi /
                100 /
                12,
            this.tenorOptions[counter]
          ) -
            1)
      );
      this.interest[counter] = Math.round(
        (this.emi[counter] * this.tenorOptions[counter] - this.gridsize) /
          this.tenorOptions[counter]
      );
      this.rateOfInterest[counter] =
        this.camp_details[0].Details.OfferGrid[index].roi;
      this.offeredInterest = this.rateOfInterest[counter];
      this.interestRate = (
        Math.round((Number(this.offeredInterest) / 12) * 100) / 100
      ).toFixed(2);
      if (this.emi[counter] > this.camp_details[0].Details.PermissibleEMI) {
        this.tenorOptions.pop();
        this.emi.pop();
        this.interest.pop();
        this.rateOfInterest.pop();
      } else {
        counter++;
      }
    }
    // this.selectedId = this.tenorOptions.length - 1;
    this.selectedId = 0;
  }

  // tenorOptionFunction(index){
  //   this.tenorOptions = [];
  //   this.emi = [];
  //   this.interest = [];
  //   this.rateOfInterest = [];
  //   let counter = 0;

  //   for (this.i = 0; this.i <= ((parseInt(this.camp_details[0].Details.OfferGrid[index].max_tenor) - parseInt(this.camp_details[0].Details.OfferGrid[index].min_tenor)) / parseInt(this.camp_details[0].Details.OfferGrid[index].stepup_tenor)); this.i++) {
  //     this.tenorOptions[counter] = parseInt(this.camp_details[0].Details.OfferGrid[index].min_tenor) + (parseInt(this.camp_details[0].Details.OfferGrid[index].stepup_tenor) * this.i);

  //     this.emi[counter] = Math.round(((((this.gridsize)*((parseInt(this.camp_details[0].Details.OfferGrid[index].roi)/100) /12)*(Math.pow((1+((parseInt(this.camp_details[0].Details.OfferGrid[index].roi)/100) /12)),this.tenorOptions[counter])))/(Math.pow((1+((parseInt(this.camp_details[0].Details.OfferGrid[index].roi)/100)/12)),this.tenorOptions[counter])-1))));

  //     this.interest[counter] = Math.round((((this.emi[counter] * this.tenorOptions[counter]) - this.gridsize) / this.tenorOptions[counter]));
  //     this.rateOfInterest[counter] = this.camp_details[0].Details.OfferGrid[index].roi;
  //     this.offeredInterest = this.rateOfInterest[counter];
  //     this.interestRate = (Math.round((Number(this.offeredInterest) / 12) * 100) / 100).toFixed(2);

  //     if(this.emi[counter] > this.camp_details[0].Details.PermissibleEMI){
  //       this.tenorOptions.pop();
  //       this.emi.pop();
  //       this.interest.pop();
  //       this.rateOfInterest.pop();
  //     } else {
  //       counter++;
  //     }
  //   }

  //   this.selectedId = 0;  // Set the first option (min-tenor) as pre-selected
  // }

  selectItem(i: any) {
    this.selectedId = i;
  }

  calculatePF(loanAmount: number, xPercent: number) {
    // console.log(loanAmount,xPercent)
    //  this.processingFeeValue = Math.max(0, xPercent * loanAmount);

    //Processing Fee changes 
    // Richa Pathak
    // 9/01/2025
    this.processingFeeValue = (Math.min(xPercent * loanAmount, 6000)).toFixed(2);
    //  console.log(this.processingFeeValue)
     this.pfgst=(this.processingFeeValue * 1.18).toFixed(2)
    this.processing_fee1 = Intl.NumberFormat("en-IN").format(
      this.pfgst
    );
    //  console.log(this.processing_fee1)
    this.disburseamount = this.topupamount - (Math.round(this.processingFeeValue * 1.18));
    this.disburseamount1 = Intl.NumberFormat("en-IN").format(
      this.disburseamount
    );
    // console.log(this.disburseamount1)
  }

  ishidden1: boolean = false;
  ishidden2: boolean = false;
  hidediv: boolean = false;
  BODY: any;
  loanOfferSubmit() {
    this.showLoader1 = true;
     
    // this.ishidden1 = !this.ishidden1
    this.ishidden2 = !this.ishidden2;

    this.hidediv = !this.hidediv;

    

    if (this.camp_category == "X-Sell") {
      this.calculatePF(this.gridsize, this.processingFeePercentage);
      this.GridAmount = this.gridsize;
      this.GridEmi = this.emi[this.selectedId];
      this.GridProcessingFee = Math.round(this.processingFeeValue * 1.18);
      this.GridTenor = this.tenorOptions[this.selectedId];
      this.GridRoi = this.rateOfInterest[this.selectedId];
      this.BODY = {
        Mobile: this.User_Mobile,
        Offer_Decision: "Accept",
        Reason: "",
        Campaign_id: sessionStorage.getItem("Campaign_Id"),
        Loan_Emi: this.emi[this.selectedId],
        Loan_Tenor: this.tenorOptions[this.selectedId],
        Proceesing_Fees: this.processingFeeValue,
        Loan_Amount: this.gridsize,
        Loan_Roi: this.rateOfInterest[this.selectedId],
        Processing_Fees_GST: (this.processingFeeValue * 1.18).toFixed(2),
        EmploymentType: this.employment_type,
        Required_Amount: "",
        Monthly_Income: this.Salary_amount,
        Mode_Of_Income: this.transaction_mode,
        Loan_Purpose: this.loan_purspose,
        Other_Loan_Purpose: this?.required_loan_amount ?? "",
        House_Hold_Income:this?.householdincome1??"",
        Timestamp:this.timestamp_terms_acceptance  
      };



       //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi )??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1?.toString())||"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""
    });
    } else if (this.camp_category == "Top-Up") {

     
      this.GridProcessingFee = this.processingFeeValue * 1.18;

      this.BODY = {
        Mobile: this.User_Mobile,
        Offer_Decision: "Accept",
        Reason: "",
        Campaign_id: sessionStorage.getItem("Campaign_Id"),
        Loan_Emi: this.offeremi,
        Loan_Tenor: this.offertenor,
        Proceesing_Fees: this.processingFeeValue,
        Loan_Amount: this.offerAmount,
        Loan_Roi: parseFloat(this.ROIAnnually),
        Processing_Fees_GST:(this.processingFeeValue * 1.18).toFixed(2),
        EmploymentType: this.employment_type,
        Required_Amount: "",
        Monthly_Income: this.Salary_amount,
        Mode_Of_Income: this.transaction_mode,
        Loan_Purpose: this.loan_purspose,
        Other_Loan_Purpose: this?.required_loan_amount ?? "",
        House_Hold_Income:this?.householdincome1??"",
        Timestamp:this.timestamp_terms_acceptance
      };


       //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi )??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1?.toString())||"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""
    });
    }
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Offer Accepted",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: this.BODY,
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});
    this.service.postOfferDecision(this.BODY).subscribe(
      (res) => {
        if (res.Status == 200) {
          this.offeraccepted = true;
          this.deviceTrack();
          this.checkcalllback();
        } else if (res.Status == 400) {
          this.offeraccepted = false;
          this.showerror = true;
          this.showLoader1 = false;

          setTimeout(() => {
            this.msgStepper_15 = true;
          }, 500);
        }
        this.Lead_id = res["Data"].Lead_Id;
        this.Application_id = res["Data"].Application_Id;
        sessionStorage.setItem("Application_id", this.Application_id);

        sessionStorage.setItem("lead_id", this.Lead_id);

        if (
          (this.insurance_flag == "true" || this.insurance_flag == true) &&
       
          this.camp_category == "X-Sell"
        ) {
          this.insurance_flag1=true
          const body = {
            Application_Id: this.Application_id,
          };  

           

          this.service.insurancedoc(body).subscribe(
            (res) => {
              this.response=res
              this.docurl =  this.response.Data["Pre-signedUrl"];
              this.insurance_premium = this.insurance_premium =
              this.response?.Data?.Insurance_details?.[0]?.insurance_premium_amount ||
                0;
            this.insurance_premium1=(this.insurance_premium)?.toString();
            // console.log( this.insurance_premium1,'premium')
             this.insurance_per_day=Math.ceil(this.insurance_premium/((this.GridTenor)* (365/12)));
              this.showinsurance = true;
              this.insurance_opted = false;
              this.netdisbusedamount = this.GridAmount - this.GridProcessingFee;
            },
            (error) => {
              this.offeraccepted = false;
              this.showerror = true;
              this.showLoader1 = false;

              setTimeout(() => {
                this.msgStepper_15 = true;
              }, 500);
            }
          );
        } else {
          this.showinsurance = false;
          this.insurance_flag1=false
          // this.netdisbusedamount=this.offerAmount-this.processing_fee;
        }
      },
      (error) => {
        // console.log(JSON.parse(decryptString(error, this.secretkey)))
        // console.log(error.error.Message)
        this.showLoader1 = false;
        this.offererror = true;
        this.ErrorMessage = error.error.Message;
      }
    );

    this.kyc_flag_status = sessionStorage.getItem("kyc_flag");
    this.nach_flag = sessionStorage.getItem("nach_flag");

    if (this.kyc_flag_status == "false") {
      this.kyc_flag = true;
    } else {
      this.kyc_flag = false;
      const body = {
        Mobile: this.User_Mobile,
      };

      this.service.getkycaddress(body).subscribe((res) => {
        this.pin = this.residenceForm1.get("Pincode").value;

        this.dob = res["Data"][0].Birthdate;
        this.firstname = res["Data"][0].FirstName
        this.lastname = res["Data"][0].LastName;

        this.MailingCity = res["Data"][0].MailingCity;

        this.MailingCountry = res["Data"][0].MailingCountry;
        this.MailingStreet = res["Data"][0].MailingStreet.replaceAll(",", ", ");
        this.MailingState = res["Data"][0].MailingState;
        this.MailingPostalCode = res["Data"][0].MailingPostalCode;

        sessionStorage.setItem("MailingCity", this.MailingCity);
        sessionStorage.setItem("MailingStreet", this.MailingStreet);
        sessionStorage.setItem("MailingState", this.MailingState);
        sessionStorage.setItem("MailingPostalCode", this.MailingPostalCode);
      });

      setTimeout(() => {
        this.msgStepper_1501 = true;
      }, 500);
      setTimeout(() => {
        this.msgStepper_1502 = true;
      }, 1000);
    }

    if (this.nach_flag == "0") {
    
      this.nach_flag_status = true;
    } else {
    
       this.nach_flag_status = false;
      // this.nach_flag_status = true;

      const body = {
        Mobile: this.User_Mobile,
      };

      this.service.nachdata(body).subscribe((res) => {
        this.Borrower_Name = res.Data.Borrower_Name__c;
        this.Borrower_Bank_Name = res.Data.Borrower_Bank_Name__c;
        this.Borrower_Account_Number = res.Data.Borrower_Account_Number__c;
        this.Borrower_IFSC = res.Data.Borrower_bank_IFSC_Number__c;
      });
    }

    setTimeout(() => {
      this.msg5 = true;
    }, 4000);
    setTimeout(() => {
      this.msg6 = true;
    }, 4500);
    setTimeout(() => {
      this.msg7 = true;
    }, 5000);
    setTimeout(() => {
      this.msg8 = true;
    }, 6000);
    setTimeout(() => {
      this.msg9 = true;
    }, 6300);
  }

  loanOfferSubmit1() {
    this.showLoader1 = true;

    this.webengage.track("Offer Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1)?.toString()||"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??""  ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });

    this.ishidden1 = !this.ishidden1;
    this.ishidden2 = !this.ishidden2;
    this.hidediv = !this.hidediv;

    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Offer Accepted",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };

    this.service.getEventTrack(body1).subscribe((res) => {});

    const body = {
      Mobile: this.User_Mobile,
      Offer_Decision: "Accept",
      Reason: "",
      Campaign_id: sessionStorage.getItem("Campaign_Id"),
    };

    this.service.postOfferDecision(body).subscribe(
      (res) => {
        if (res.Status == 200) {
          this.checkcalllback();
        } else {
          this.showerror = true;
          this.showLoader1 = false;
          setTimeout(() => {
            this.msgStepper_15 = true;
          }, 500);
        }
        this.Lead_id = res["Data"].Lead_Id;
        this.Application_id = res["Data"].Application_Id;
        sessionStorage.setItem("Application_id", this.Application_id);

        sessionStorage.setItem("lead_id", this.Lead_id);
      },
      (error) => {
        // console.log(JSON.parse(decryptString(error, this.secretkey)))
        // console.log(error.error.Message)
        this.showLoader1 = false;
        this.offererror = true;
        this.ErrorMessage = error.error.Message;
      }
    );

    this.kyc_flag_status = sessionStorage.getItem("kyc_flag");
    this.nach_flag = sessionStorage.getItem("nach_flag");

    if (this.kyc_flag_status == "false") {
      this.kyc_flag = true;
    } else {
      this.kyc_flag = false;
      const body = {
        Mobile: this.User_Mobile,
      };
      this.service.getkycaddress(body).subscribe((res) => {
        this.pin = this.residenceForm1.get("Pincode").value;

        this.dob = res["Data"][0].Birthdate;
        this.firstname = res["Data"][0].FirstName;
        this.lastname = res["Data"][0].LastName;

        this.MailingCity = res["Data"][0].MailingCity;

        this.MailingCountry = res["Data"][0].MailingCountry;
        this.MailingStreet = res["Data"][0].MailingStreet.replaceAll(",", ", ");
        this.MailingState = res["Data"][0].MailingState;
        this.MailingPostalCode = res["Data"][0].MailingPostalCode;

        sessionStorage.setItem("MailingCity", this.MailingCity);
        sessionStorage.setItem("MailingStreet", this.MailingStreet);
        sessionStorage.setItem("MailingState", this.MailingState);
        sessionStorage.setItem("MailingPostalCode", this.MailingPostalCode);
      });

      setTimeout(() => {
        this.msgStepper_1501 = true;
      }, 500);
      setTimeout(() => {
        this.msgStepper_1502 = true;
      }, 1000);
    }

    if (this.nach_flag == "0") {
      this.nach_flag_status = true;
    } else {
      this.nach_flag_status = false;
      const body = {
        Mobile: this.User_Mobile,
      };
      this.service.nachdata(body).subscribe((res) => {
        this.Borrower_Name = res.Data.Borrower_Name__c;
        this.Borrower_Bank_Name = res.Data.Borrower_Bank_Name__c;
        this.Borrower_Account_Number = res.Data.Borrower_Account_Number__c;
        this.Borrower_IFSC = res.Data.Borrower_bank_IFSC_Number__c;
      });
    }

    setTimeout(() => {
      this.msg5 = true;
    }, 4000);
    setTimeout(() => {
      this.msg6 = true;
    }, 4500);
    setTimeout(() => {
      this.msg7 = true;
    }, 5000);
    setTimeout(() => {
      this.msg8 = true;
    }, 6000);
    setTimeout(() => {
      this.msg9 = true;
    }, 6300);
  }

  offerNotInter() {
    this.msgStepper_803 = false;
    this.msgStepper_Offer = false;
    setTimeout(() => {
      this.msgStepper_1109 = true;
    }, 500);
  }

  Hide1: boolean = true;
  onKYCproceed() {
    this.isKYCprocees = true;
  }

  LATLONG;
  LATITUDE;

  isenable;
  Allowloaction: boolean = false;
  msgStepper_200: boolean;
  msgStepper_119: boolean;
  ResumeAmount: any;
  ResumeTenor: any;
  ResumeEMI: any;
  ResumeInterest: any;
  OfferAccepted: boolean = true;
  checkresumejourney() {
    
    this.showofferLoader = true;
    this.resumeloader = false;

    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.resume_journey(body).subscribe((res) => {
      

      this.resumejourney = res;
      this.curing_status = this.resumejourney.Data.Curing_Status.Status;
      // console.log(this.curing_status,'curing status')
      this.comnadress = sessionStorage.getItem("com_add_flag");

      if (this.resumejourney.Message == "Data Not Found") {
         
        this.hidediv = false;

        this.showcuringloader = false;
        this.showofferLoader = false;
        this.emp_type=null
        this.employment_type=null;
        this.salary=null;
        this.salary_mode=null;
        this.purspose=null;

        return;
      }
      if (this.curing_status == "Approved") {
        this.showcuringloader = false;
        this.curing_emandate = true;
        return;
      } else {
       
        this.curing_journey = false;
        this.otpverified=true;
        this.showcuringloader = false;
        this.showofferLoader = false;
        this.resumeloader = false;
        this.hidediv = true;
        

        this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
        this.Lid = this.resumejourney.Data.Lead_Id;
        this.kycstatus = this.resumejourney.Data.KYC_Status;
        this.isContactupdated =
          this.resumejourney.Data.Customer_Lead_Contact_Update;
        this.oppid = this.resumejourney.Data.Opportunity_Id;
        this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
        this.rfc = this.resumejourney.Data.Ready_For_Conversion;
        this.LDSstatus = this.resumejourney.Data.LDS_Status;
        this.appid = this.resumejourney.Data.Application_ID;
        this.Application_id = this.appid;
        sessionStorage.setItem("Application_id", this.appid);
        this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
        this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
        this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
        this.MailingStreet =
          this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
        this.MailingPostalCode =
          this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
        this.MailingCity =
          this.resumejourney.Data.KYC_Existing_Data.MailingCity;
        this.MailingState =
          this.resumejourney.Data.KYC_Existing_Data.MailingState;
        this.MailingCountry =
          this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
        this.addressverified =
          this.resumejourney.Data.Campaign.address_verify_button;
        this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
        this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
        // this.insurance_premium= this.resumejourney.Data.Campaign.Insurance_Premium__c
        this.insurance_flag =
          this.resumejourney.Data.Campaign.Insurance_Offered__c;
        this.camp_category = this.resumejourney.Data.Campaign.Campaign_Category__c;
        //  this.resumejourney.Data.Campaign.Campaign_Category__c="X-Sell"
        this.r_kyc_flag =
          this.resumejourney.Data.Campaign.Existing_KYC_Use_Flag__c;
        this.r_nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
        if (this.resumejourney.Data.Campaign.Campaign_Category__c == "X-Sell") {
          this.GridAmount = this.resumejourney.Data.Campaign.Offered_Amount__c;
          this.GridEmi = this.resumejourney.Data.Campaign.EMI__c;
          this.GridRoi = this.resumejourney.Data.Campaign.Offered_ROI__c;
          this.GridTenor = this.resumejourney.Data.Campaign.Offered_Tenor__c;
          this.GridProcessingFee =
            this.resumejourney.Data.Campaign.Processing_Fees_GST__c;
        }
        if (this.resumejourney.Data.Lead_Id != "") {
          //PA changes
       
          this.OfferAccepted = false;
          this.ResumeAmount =
            this.resumejourney.Data.Campaign.Offered_Amount__c;
          this.ResumeTenor = this.resumejourney.Data.Campaign.Offered_Tenor__c;
          this.ResumeEMI = this.resumejourney.Data.Campaign.EMI__c;
          this.ResumeInterest = Math.round(
            (this.resumejourney.Data.Campaign.EMI__c *
              this.resumejourney.Data.Campaign.Offered_Tenor__c -
              this.resumejourney.Data.Campaign.Offered_Amount__c) /
              this.resumejourney.Data.Campaign.Offered_Tenor__c
          );
        } else {
          this.hidediv = false;
          this.showLoader1 = false;
          this.resumeloader = false;
        }
        if (this.comnadress == "true") {
          sessionStorage.setItem("MailingCity", this.MailingCity);
          sessionStorage.setItem("MailingStreet", this.MailingStreet);
          sessionStorage.setItem("MailingState", this.MailingState);
          sessionStorage.setItem("MailingPostalCode", this.MailingPostalCode);
        }

        if (
          (this.insurance_flag == "true" || this.insurance_flag == true) &&
          this.camp_category == "X-Sell" &&
          this.Application_id != "" &&
          this.Application_id != null
        ) {
          const body = {
            Application_Id: this.Application_id,
          };
       
              
          this.service.insurancedoc(body).subscribe(
            (res) => {
              this.response=res
              this.docurl = this.response.Data["Pre-signedUrl"];
              this.insurance_premium = this.insurance_premium =
              this.response?.Data?.Insurance_details?.[0]?.insurance_premium_amount ||
                0;
                  this.insurance_premium1=(this.insurance_premium)?.toString();
              // console.log( this.insurance_premium1,'insurance')
              this.insurance_per_day=Math.ceil(this.insurance_premium/((this.GridTenor)* (365/12)));
              this.showinsurance = true;
              this.insurance_opted = false;
              this.netdisbusedamount = this.GridAmount - this.GridProcessingFee;
            },
            (error) => {
              this.offeraccepted = false;
              this.showerror = true;
              this.showLoader1 = false;

              setTimeout(() => {
                this.msgStepper_15 = true;
              }, 500);
            }
          );
        } else {
          this.showinsurance = false;
          // this.netdisbusedamount=this.offerAmount-this.processing_fee;
        }

        if (this.nach_flag == "0") {
          this.nach_flag_status = true;
        } else {
          this.nach_flag_status = false;
        }

        if (this.r_kyc_flag == "false" && this.r_nach_flag == "0") {
          this.resumejourney1();
        } else if (this.r_kyc_flag == "false" && this.r_nach_flag == "1") {
          this.resumejourney2();
        } else if (
          this.r_kyc_flag == "true" &&
          this.r_nach_flag == "0" &&
          this.comnadress == "true"
        ) {
          this.resumejourney3();
        } else if (
          this.r_kyc_flag == "true" &&
          this.r_nach_flag == "1" &&
          this.comnadress == "true"
        ) {
          this.resumejourneynach();
        } else if (
          this.r_kyc_flag == "true" &&
          this.r_nach_flag == "0" &&
          this.comnadress == "false"
        ) {
          this.resumejourney4();
        } else if (
          this.r_kyc_flag == "true" &&
          this.r_nach_flag == "1" &&
          this.comnadress == "false"
        ) {
          this.resumejourney5();
        }
      }
    });
  }
  async deviceTrack() {
    // this.showofferLoader = true;
    // this.resumeloader = false;
    let info = this.device.getDeviceInfo();

    let deviceType: string;
    if (info) {
      this.devicedialogopen = true;

      if (this.device.isMobile()) {
        deviceType = "Mobile";
      } else if (this.device.isTablet()) {
        deviceType = "Tablet";
      } else if (this.device.isDesktop()) {
        deviceType = "Desktop";
      }

      let latLong: any;

      try {
        this.webengage.track("Location Access Enabling Prompted", {
          "Campaign Type": this.camp_type??"",
          "Campaign Category": this.camp_category??"",
          "Campaign Sub Category": this.camp_sub_category??"",
          "Program Type": this.program_type??"",   
          "Sourcing Channel": this.sourcing_channel??"",     
          "Product Structure": this.prod_structure??"",
          "Product Name": this.prod_name??"",
          "Customer Segment": this.cust_segment??"",
          "Offer Amount": parseInt(this.offerAmount)??"",   
          "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
          "Lead Source":"X-Sell",
           "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
            "Household Income":(this.householdincome1)?.toString()||"",
            "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
            "Monthly Income":(this.Salary_amount||this.salary)?.toString()??"" ,     
            "Employment Type":(this.emp_type||this.employment_type)??"",
          "Existing KYC Flag": this.kyc_webengage??"",
          "Existing Mandate Flag":(this.nach)?.toString()||"",
          "Carry Forward Flag":this.carry_forward??"",         
          "CPV Flag":this.stp_flag??""
        });  
        setTimeout(async () => {
          this.latlongresponse = await this.getCurrentLatLong();

          this.devicelongitude = this.latlongresponse.longitude;
          this.devicelatitude = this.latlongresponse.latitude;

          if (this.devicelatitude != "" && this.devicelongitude != "") {
            // this.showcuringloader=true;
            this.devicedialogopen = false;
                
            // this.resumeloader = true;
            this.isenable = true;
            this.Allowloaction = false;
            this.msgStepper_112111 = false;

            setTimeout(() => {
              this.msgStepper_119 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_200 = true;
            }, 1300);
          }
          this.Mobile = this.User_Mobile;

          const body = {
            Request_Key: "",
            Mobile: this.User_Mobile,
            Device_Info: deviceType,
            Browser_Info: this.device.browser,
            Longitude: this.devicelongitude,
            Latitude: this.devicelatitude,
            Location: "Null",
            OS_Type: this.device.os,
            Partner_Name: "DMI Finance",
          };

          this.service.getDeviceTrack(body).subscribe();
        }, 5000);
      } catch (error) {
        latLong = error;
      }
    }
  }
  afterVerifedOTP1: boolean = false;
  getCurrentLatLong(): Promise<any> {
    // this.hidediv = true;

    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({
            longitude: resp.coords.longitude,
            latitude: resp.coords.latitude,
          });
          if (resolve) {
            this.showofferLoader = false;
            setTimeout(() => {
              this.msgStepper_112 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_113 = true;
            }, 1300);
            this.spinner.show();
            setTimeout(() => {
              this.msgspinner = true;
            }, 1500);

            setTimeout(() => {
              this.spinner.hide();
              this.msgspinner = false;

              (this.showDialog = true),
                setTimeout(() => {
                  this.msgStepper_dialog = true;
                }, 1500);
            }, 1300);
          }
        },
        (err) => {
          reject({ longitude: "", latitude: "" });
          if (reject) {
            this.devicedialogopen = false;
            this.otpOption = false;
            this.showofferLoader = false;
            setTimeout(() => {
              this.msgStepper_112111 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_1121 = true;
            }, 500);

            setTimeout(() => {
              this.msgStepper_112 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_113 = false;
            }, 1300);
            this.spinner.show();
            setTimeout(() => {
              this.msgspinner = false;
            }, 1500);

            setTimeout(() => {
              this.spinner.hide();
              this.msgspinner = false;

              (this.showDialog = true),
                setTimeout(() => {
                  this.msgStepper_dialog = false;
                }, 1500);
            }, 1300);
          }
        }
      );
    });
  }

  Retrylocation() {
    this.Allowloaction = true;
    this.deviceTrack();
  }
  rfcFailed1: boolean = false;
  resumejourney1() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =
      this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;
    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);
    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;

    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.istermsaccepted=true;
      this.msgStepper_001 = true;
      this.msgStepper_0001 = true;
      this.is_Employement_submmited = true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
          this.deviceTrack();

      if (this.kycstatus == "" || this.kycstatus == null) {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
      } else if (this.kycstatus == "Retry") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
      } else if (this.kycstatus == "Failed") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
      } else if (this.kycstatus == "Rejected") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);

        this.isKYCSuccess = false;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg_61 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_62 = true;
        }, 800);
      } else {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
        this.isKYCSuccess = true;

        setTimeout(() => {
          this.msgStepper_403 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_404 = true;
        }, 600);
        setTimeout(() => {
          this.msgStepper_405 = true;
        }, 700);
        setTimeout(() => {
          this.msgStepper_501 = true;
        }, 700);
        setTimeout(() => {
          this.msgStepper_506 = true;
        }, 700);
        this.residenceForm.patchValue({
          flat: this.resumejourney.Data.KYC_Data[0].Street,
          landmark: this.resumejourney.Data.KYC_Data[0].Street.landmark || "",
          postOffice: this.resumejourney.Data.KYC_Data[0].Post_Office,
          District: this.resumejourney.Data.KYC_Data[0].District,
          Pincode: this.resumejourney.Data.KYC_Data[0].Pincode,
          State: this.resumejourney.Data.KYC_Data[0].State.toUpperCase(),
        });

        if (this.isContactupdated == true) {
          this.hidesubmit = true;
          this.ishiddencom = true;
          this.iscommupdated = true;
          setTimeout(() => {
            this.msg21 = true;
          }, 700);

          if (
            this.oppid != "" &&
            this.peenydrop == "APPROVED" &&
            this.rfc == "Success" &&
            (this.nachstatus == "success" || this.nachstatus == "Success")
          ) {
            if (this.camp_category == "Top-Up") {
              this.get_Existing_Loan();
            }
            this.iscommupdated = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = true;
            this.KFS_otp_send();
            setTimeout(() => {
              this.msgStepper_904 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_10021 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_topup = true;
            }, 550);
            setTimeout(() => {
              this.msgStepper_10011 = true;
            }, 500);
          } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
            this.iscommupdated = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 500);
          } else if (
            this.peenydrop == "REJECTED" ||
            this.nachstatus == "Rejected" ||
            this.nachstatus == "REJECTED"
          ) {
            this.iscommupdated = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 500);
          } else if (this.oppid == "" && this.peenydrop == "APPROVED") {
            this.iscommupdated = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = false;
            this.kyc_flag = true;
            this.ldsloader = false;
          } else {
            this.iscommupdated = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = false;
            this.kyc_flag = true;
            this.ldsloader = false;
          }
        } else {
          this.hidesubmit = false;
          this.iscommupdated = false;
          this.ishiddencom = false;
          this.nach_flag_status = true;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
        }
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = false;
      this.hidediv = false;
    }
  }

  resumejourney2() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;
    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);
    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
    this.nach_click = this.resumejourney.Data.Campaign.nach_button;
   
    const body = {
      Mobile: this.User_Mobile,
    };
    this.service.nachdata(body).subscribe((res) => {
      this.Borrower_Name = res.Data.Borrower_Name__c;
      this.Borrower_Bank_Name = res.Data.Borrower_Bank_Name__c;
      this.Borrower_Account_Number = res.Data.Borrower_Account_Number__c;
      this.Borrower_IFSC = res.Data.Borrower_bank_IFSC_Number__c;
    });
    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.msgStepper_001 = true;
      this.istermsaccepted=true;
       this.msgStepper_0001 = true;
      this.is_Employement_submmited = true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
  this.deviceTrack();
      if (this.kycstatus == "Rejected") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);

        this.isKYCSuccess = false;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg_61 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_62 = true;
        }, 800);
      } else if (this.kycstatus == "Failed") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
        this.nach_flag_status = false;
      } else if (this.kycstatus == "" || this.kycstatus == null) {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
        this.nach_flag_status = false;
      } else if (this.kycstatus == "Retry") {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = false;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
        this.nach_flag_status = false;
      } else {
        this.resumekyc = true;
        this.offeraccepted = true;
        this.isDisabled = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        setTimeout(() => {
          this.msg9 = true;
        }, 600);
        this.isKYCSuccess = true;

        setTimeout(() => {
          this.msgStepper_403 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_404 = true;
        }, 600);
        setTimeout(() => {
          this.msgStepper_405 = true;
        }, 700);
        setTimeout(() => {
          this.msgStepper_501 = true;
        }, 700);
        setTimeout(() => {
          this.msgStepper_506 = true;
        }, 700);
        this.residenceForm.patchValue({
          flat: this.resumejourney.Data.KYC_Data[0].Street,
          landmark: this.resumejourney.Data.KYC_Data[0].Street.landmark || "",
          postOffice: this.resumejourney.Data.KYC_Data[0].Post_Office,
          District: this.resumejourney.Data.KYC_Data[0].District,
          Pincode: this.resumejourney.Data.KYC_Data[0].Pincode,
          State: this.resumejourney.Data.KYC_Data[0].State.toUpperCase(),
        });

        if (this.isContactupdated == true) {
          this.hidesubmit = true;
          this.ishiddencom = true;
          this.iscommupdated = true;
          if (
            this.oppid == "" &&
            this.peenydrop == "" &&
            (this.nach_click == null || this.nach_click == "Yes")
          ) {
            this.iscommupdated = true;

            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            this.kyc_flag = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);

            this.ldsloader = false;

            this.isEMandateCompleted = false;
            this.ldsloader = false;
          }

          if (
            this.oppid != "" &&
            this.peenydrop == "APPROVED" &&
            (this.nach_click == "Yes" || this.nach_click == "No") &&
            (this.nachstatus == "success" || this.nachstatus == "Success")
          ) {
            if (this.camp_category == "Top-Up") {
              this.get_Existing_Loan();
            }

            this.iscommupdated = true;
            this.isnachyes = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.hidenachbutton = true;
            this.isEMandateCompleted = true;
            this.KFS_otp_send();
            setTimeout(() => {
              this.msgStepper_904 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_10021 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_topup = true;
            }, 550);
            setTimeout(() => {
              this.msgStepper_10011 = true;
            }, 500);
          } else if (
            (this.nach_click == "Yes" || this.nach_click == "No") &&
            (this.peenydrop == "REJECTED" ||
              this.nachstatus == "Rejected" ||
              this.nachstatus == "REJECTED")
          ) {
            this.iscommupdated = true;
            this.isnachyes = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = false;
            this.loader4 = false;
            this.isrejected = true;
            this.hidenachbutton = true;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 800);
            this.ldsloader = false;
          } else if (this.nach_click == "No") {
            this.iscommupdated = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            setTimeout(() => {
              this.msg22 = true;
            }, 700);

            this.kyc_flag = true;
            this.ldsloader = false;
            this.hidenachbutton = true;
            this.non_existing_nach = true;
          } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
            this.iscommupdated = true;
            this.isnachyes = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = false;
            this.loader4 = false;
            this.isrejected = true;
            this.hidenachbutton = true;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 800);
            this.ldsloader = false;
          } else {
            this.iscommupdated = true;

            setTimeout(() => {
              this.msg21 = true;
            }, 700);
            this.kyc_flag = true;
            this.nach_flag_status = false;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);

            this.ldsloader = false;

            this.isEMandateCompleted = false;
            this.ldsloader = false;
          }
        } else {
          this.hidesubmit = false;
          this.ishiddencom = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.ldsloader = false;
        }
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = false;
      this.hidediv = false;
    }
  }

  resumejourney3() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =
      this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;

    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);

    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;

    this.MailingCountry ==
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;

    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.msgStepper_001 = true;
      this.msgStepper_0001 = true;
      this.istermsaccepted=true;
      this.is_Employement_submmited = true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
          this.deviceTrack();
    
      if (this.kycbutton == null || this.addressverified == null) {
        this.resumekyc = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 1000);
        this.kycaddress = true;
        this.hideaddress = false;
      }
      if (this.kycbutton == "Yes" && this.addressverified == "Yes") {
        this.resumekyc = true;
        this.addressrequired = false;
        setTimeout(() => {
          this.msgStepper_34 = true;
        }, 1000);
        setTimeout(() => {
          this.msgStepper_50 = true;
        }, 1000);
        this.kycaddress = true;
        this.hideaddress = !this.hideaddress;
        setTimeout(() => {
          this.msgStepper_200 = true;
        }, 500);
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        this.hidebutton1 = true;

        if (this.kycstatus == "" || this.kycstatus == null) {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.nach_flag_status = true;
          this.isDisabled2 = false;
          return;
        } else if (this.kycstatus == "Retry") {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.nach_flag_status = true;
          this.isDisabled2 = false;
          return;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else if (this.kycstatus == "Failed") {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.nach_flag_status = true;
          this.isDisabled2 = false;
          return;
        } else {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = true;
          this.isSelfie = true;

          setTimeout(() => {
            this.msgStepper_39 = true;
          }, 800);
          this.iscommupdated = true;
          this.nach_flag_status = true;
          if (this.isContactupdated == true) {
            this.hidesubmit = true;

            if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              this.rfc == "Success" &&
              (this.nachstatus == "success" || this.nachstatus == "Success")
            ) {
              this.iscommupdated = true;
              this.nach_flag_status = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;

              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_topup = true;
              }, 550);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (
              this.peenydrop == "REJECTED" ||
              this.nachstatus == "Rejected" ||
              this.nachstatus == "REJECTED"
            ) {
              this.isEMandateCompleted = false;
              this.isDisabled2 = true;
              this.loader4 = false;
              this.ldsloader = false;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.isEMandateCompleted = false;
              this.isDisabled2 = true;
              this.loader4 = false;
              this.ldsloader = false;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
            } else {
              this.iscommupdated = true;
              this.nach_flag_status = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = false;
              this.kyc_flag = true;
            }
          }
        }
      }

      if (this.addressverified == "No" && this.kycbutton == "Yes") {
        this.disablebutton = true;
        if (this.kycstatus == "" || this.kycstatus == null) {
          this.hideaddress = !this.hideaddress;

          this.resumekyc = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
        } else if (this.kycstatus == "Retry") {
          this.hideaddress = !this.hideaddress;

          this.resumekyc = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
        } else if (this.kycstatus == "Failed") {
          this.hideaddress = !this.hideaddress;
          this.resumekyc = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          this.resumekyc = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);
          this.isrepeateKyc = true;
          setTimeout(() => {
            this.msgStepper_30 = true;
          }, 800);

          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          if (this.isContactupdated == true) {
            this.addressrequired = true;
            setTimeout(() => {
              this.msgStepper_33 = true;
            }, 800);
            this.iscommupdated1 = true;
            this.ishiddencom = true;
            setTimeout(() => {
              this.msg21 = true;
            }, 1000);
            //setTimeout(() => { this.msg22 = true; }, 1000);
            this.isSelfie = true;
            setTimeout(() => {
              this.msg20 = true;
            }, 1000);
            this.hidebutton2 = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msgStepper_39 = true;
            }, 800);
            this.residenceForm1.patchValue({
              flat: this.MailingStreet,
              postOffice: this.MailingCity,
              District: this.MailingCity,
              Pincode: this.MailingPostalCode,
              State: this.MailingState.toUpperCase(),
            });

            if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              this.rfc == "Success"
            ) {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;
              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              this.ishiddencom = true;
              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (this.peenydrop == "REJECTED") {
              this.isEMandateCompleted = false;
              this.loader4 = false;
              this.isDisabled2 = true;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else if (this.oppid == "" && this.peenydrop == "APPROVED") {
              this.iscommupdated1 = true;
              this.nach_flag_status = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = false;
              this.kyc_flag = true;
              this.ldsloader = false;
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.isEMandateCompleted = false;
              this.loader4 = false;
              this.isDisabled2 = true;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else {
              this.iscommupdated1 = true;
              this.nach_flag_status = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = false;
              this.kyc_flag = true;
            }
          }
        }
      }

      if (this.kycbutton == "No") {
        this.kycaddress = true;
        this.hideaddress = !this.hideaddress;
        setTimeout(() => {
          this.msgStepper_200 = true;
        }, 500);
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        this.hidebutton1 = true;
        this.isrepeateKyc = true;
        setTimeout(() => {
          this.msgStepper_30 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_32 = true;
        }, 500);
        this.resumekyc = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 700);
        if (this.kycstatus == "" || this.kycstatus == null) {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = true;
        } else if (this.kycstatus == "Retry") {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = true;
        } else if (this.kycstatus == "Failed") {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = true;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          this.isrepeateKyc = true;
          this.offeraccepted = true;
          this.isDisabled = true;
          setTimeout(() => {
            this.msgStepper_30 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_32 = true;
          }, 500);
          this.isKYCSuccess = true;

          setTimeout(() => {
            this.msgStepper_403 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_404 = true;
          }, 600);
          setTimeout(() => {
            this.msgStepper_405 = true;
          }, 700);
          setTimeout(() => {
            this.msgStepper_501 = true;
          }, 700);
          setTimeout(() => {
            this.msgStepper_506 = true;
          }, 700);
          this.residenceForm.patchValue({
            flat: this.resumejourney.Data.KYC_Data[0].Street,
            landmark: this.resumejourney.Data.KYC_Data[0].Street.landmark || "",
            postOffice: this.resumejourney.Data.KYC_Data[0].Post_Office,
            District: this.resumejourney.Data.KYC_Data[0].District,
            Pincode: this.resumejourney.Data.KYC_Data[0].Pincode,
            State: this.resumejourney.Data.KYC_Data[0].State.toUpperCase(),
          });

          if (this.isContactupdated == true) {
            this.hidesubmit = true;
            this.ishiddencom = true;
            this.iscommupdated = true;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);

            if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              this.rfc == "Success"
            ) {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }
              this.iscommupdated = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;

              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_topup = true;
              }, 550);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (this.peenydrop == "REJECTED") {
              this.iscommupdated = true;

              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;

              this.isEMandateCompleted = false;
              this.isDisabled2 = true;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
            } else if (this.oppid == "" && this.peenydrop == "APPROVED") {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }
              this.iscommupdated = true;

              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = false;
              this.kyc_flag = true;
              this.ldsloader = false;
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.iscommupdated = true;

              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;

              this.isEMandateCompleted = false;
              this.isDisabled2 = true;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
            } else {
              this.iscommupdated = true;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = false;
              this.kyc_flag = true;
              this.isEMandateCompleted = false;
              setTimeout(() => {
                this.msgStepper_904 = false;
              }, 700);
              this.ldsloader = false;
            }
          } else {
            this.hidesubmit = false;
            this.iscommupdated = false;
            this.ishiddencom = false;
            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msg21 = false;
            }, 700);
            setTimeout(() => {
              this.msgStepper_904 = false;
            }, 700);
          }
        }
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = false;
      this.hidediv = false;
    }
  }

  resumejourneynach() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =
      this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;
    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);
    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;

    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
    this.nach_click = this.resumejourney.Data.Campaign.nach_button;
    const body = {
      Mobile: this.User_Mobile,
    };
    this.service.nachdata(body).subscribe((res) => {
      this.Borrower_Name = res.Data.Borrower_Name__c;
      this.Borrower_Bank_Name = res.Data.Borrower_Bank_Name__c;
      this.Borrower_Account_Number = res.Data.Borrower_Account_Number__c;
      this.Borrower_IFSC = res.Data.Borrower_bank_IFSC_Number__c;
    });

    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.msgStepper_001 = true;
      this.is_Employement_submmited = true;
      this.istermsaccepted=true;
      this.msgStepper_0001 = true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
          this.deviceTrack();
      if (this.kycbutton == null || this.addressverified == null) {
        this.resumekyc = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 1000);
        this.kycaddress = true;
        this.hideaddress = false;
      }

      if (this.kycbutton == "Yes" && this.addressverified == "Yes") {
        this.resumekyc = true;
        this.addressrequired = false;
        setTimeout(() => {
          this.msgStepper_34 = true;
        }, 1000);
        setTimeout(() => {
          this.msgStepper_50 = true;
        }, 1000);
        this.kycaddress = true;
        this.hideaddress = !this.hideaddress;
        setTimeout(() => {
          this.msgStepper_200 = true;
        }, 500);
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        this.hidebutton1 = true;

        if (this.kycstatus == "" || this.kycstatus == null) {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;
          this.nach_flag_status = false;
          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.isDisabled2 = false;
          return;
        } else if (this.kycstatus == "Retry") {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;
          this.nach_flag_status = false;
          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.isDisabled2 = false;
          return;
        } else if (this.kycstatus == "Failed") {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = false;
          this.isSelfie = false;
          this.nach_flag_status = false;
          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 800);

          this.isDisabled2 = false;
          return;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          this.isSameAddress = true;
          setTimeout(() => {
            this.msgStepper_35 = true;
          }, 800);
          setTimeout(() => {
            this.msgStepper_36 = true;
          }, 800);
          this.hidebutton2 = true;
          this.isSelfie = true;
          this.isDisabled2 = true;
          setTimeout(() => {
            this.msgStepper_39 = true;
          }, 800);
          this.iscommupdated1 = false;
          this.nach_flag_status = false;
          if (this.isContactupdated == true) {
            this.hidesubmit = true;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);

            this.loader4 = false;

            if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              (this.nach_click == "Yes" || this.nach_click == "No") &&
              (this.nachstatus == "success" || this.nachstatus == "Success")
            ) {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }
              this.hidenachbutton = true;
              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              this.ldsloader = false;
              this.isnachyes = true;

              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_topup = true;
              }, 550);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (
              this.oppid == "" &&
              this.peenydrop == " " &&
              (this.nach_click == "Yes" || this.nach_click == null)
            ) {
              this.hidenachbutton = false;
              this.isDisabled2 = false;
            } else if (
              (this.peenydrop == "REJECTED" ||
                this.nachstatus == "Rejected" ||
                this.nachstatus == "REJECTED") &&
              (this.nach_click == "Yes" || this.nach_click == "No")
            ) {
              this.isrejected = true;

              this.hidenachbutton = true;
              this.isDisabled2 = true;
              this.isEMandateCompleted = false;
              this.loader4 = false;
              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else if (this.nach_click == "No") {
              this.hidenachbutton = true;
              this.non_existing_nach = true;
              this.isDisabled2 = false;
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.isrejected = true;

              this.hidenachbutton = true;
              this.isDisabled2 = true;
              this.isEMandateCompleted = false;
              this.loader4 = false;
              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else {
            }
          }
        }
      }
      if (this.addressverified == "No" && this.kycbutton == "Yes") {
        if (this.kycstatus == "" || this.kycstatus == null) {
          this.resumekyc = true;
          this.disablebutton = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Retry") {
          this.resumekyc = true;
          this.disablebutton = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Failed") {
          this.resumekyc = true;
          this.disablebutton = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);
          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          this.resumekyc = true;
          this.addressrequired = false;
          setTimeout(() => {
            this.msgStepper_50 = true;
          }, 1000);
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);
          this.isrepeateKyc = true;
          setTimeout(() => {
            this.msgStepper_30 = true;
          }, 800);

          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.isnotSameAddress = true;
          setTimeout(() => {
            this.msgStepper_37 = true;
          }, 800);

          if (this.isContactupdated == true) {
            this.residenceForm1.patchValue({
              flat: this.MailingStreet,
              postOffice: this.MailingCity,
              District: this.MailingCity,
              Pincode: this.MailingPostalCode,
              State: this.MailingState.toUpperCase(),
            });
            this.addressrequired = true;
            setTimeout(() => {
              this.msgStepper_33 = true;
            }, 800);
            this.iscommupdated1 = true;
            this.iscommupdated = true;
            this.ishiddencom = true;
            setTimeout(() => {
              this.msg20 = true;
            }, 1000);
            setTimeout(() => {
              this.msg22 = true;
            }, 1000);
            this.hidebutton2 = true;
            this.isSelfie = true;
            setTimeout(() => {
              this.msgStepper_39 = true;
            }, 800);
            this.nach_flag_status = false;

            this.loader4 = false;
            if (
              this.oppid == "" &&
              this.peenydrop == "" &&
              (this.nach_click == "Yes" || this.nach_click == null)
            ) {
              this.isSelfie = true;
              setTimeout(() => {
                this.msgStepper_39 = true;
              }, 500);
              this.nach_flag_status = false;
              this.hidenachbutton = false;
              this.isDisabled2 = false;
            } else if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              (this.nach_click == "Yes" || this.nach_click == "No")
            ) {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }

              this.ldsloader = false;
              this.hidenachbutton = true;
              this.isnachyes = true;
              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_topup = true;
              }, 550);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (
              (this.nach_click == "Yes" || this.nach_click == "No") &&
              this.peenydrop == "REJECTED"
            ) {
              this.isrejected = true;
              this.isEMandateCompleted = false;
              this.hidenachbutton = true;
              this.loader4 = false;
              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else if (this.nach_click == "No" && this.peenydrop == null) {
              this.hidenachbutton = true;
              this.non_existing_nach = true;
              this.isDisabled2 = false;
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.isrejected = true;
              this.isEMandateCompleted = false;
              this.hidenachbutton = true;
              this.loader4 = false;
              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);
              this.ldsloader = false;
            } else {
            }
          }
        }
      }

      if (this.kycbutton == "No") {
        this.kycaddress = true;
        this.hideaddress = !this.hideaddress;
        setTimeout(() => {
          this.msgStepper_200 = true;
        }, 500);
        setTimeout(() => {
          this.msg8 = true;
        }, 500);
        this.hidebutton1 = true;
        this.isrepeateKyc = true;
        setTimeout(() => {
          this.msgStepper_30 = true;
        }, 500);
        setTimeout(() => {
          this.msgStepper_32 = true;
        }, 500);

        this.resumekyc = true;
        setTimeout(() => {
          this.msg8 = true;
        }, 700);
        if (this.kycstatus == "" || this.kycstatus == null) {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = false;
        } else if (this.kycstatus == "Retry") {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = false;
        } else if (this.kycstatus == "Failed") {
          this.isDisabled = false;
          this.iscommupdated = false;
          setTimeout(() => {
            this.msg21 = false;
          }, 700);
          this.isKYCSuccess = false;
          this.nach_flag_status = false;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          this.isrepeateKyc = true;
          this.offeraccepted = true;
          this.isDisabled = true;
          setTimeout(() => {
            this.msgStepper_30 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_32 = true;
          }, 500);
          this.isKYCSuccess = true;
          setTimeout(() => {
            this.msgStepper_403 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_404 = true;
          }, 600);
          setTimeout(() => {
            this.msgStepper_405 = true;
          }, 700);
          setTimeout(() => {
            this.msgStepper_501 = true;
          }, 700);
          setTimeout(() => {
            this.msgStepper_506 = true;
          }, 700);
          this.residenceForm.patchValue({
            flat: this.resumejourney.Data.KYC_Data[0].Street,
            landmark: this.resumejourney.Data.KYC_Data[0].Street.landmark || "",
            postOffice: this.resumejourney.Data.KYC_Data[0].Post_Office,
            District: this.resumejourney.Data.KYC_Data[0].District,
            Pincode: this.resumejourney.Data.KYC_Data[0].Pincode,
            State: this.resumejourney.Data.KYC_Data[0].State.toUpperCase(),
          });

          if (this.isContactupdated == true) {
            this.hidesubmit = true;
            this.ishiddencom = true;
            this.iscommupdated = true;
            setTimeout(() => {
              this.msg21 = true;
            }, 700);

            if (
              this.oppid == "" &&
              this.peenydrop == "" &&
              (this.nach_click == null || this.nach_click == "Yes")
            ) {
              this.iscommupdated = true;

              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              this.kyc_flag = true;
              this.nach_flag_status = false;
              setTimeout(() => {
                this.msg22 = true;
              }, 700);

              this.ldsloader = false;

              this.isEMandateCompleted = false;
              this.ldsloader = false;
            }

            if (
              this.oppid != "" &&
              this.peenydrop == "APPROVED" &&
              (this.nach_click == "Yes" || this.nach_click == "No")
            ) {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }

              this.iscommupdated = true;
              this.isnachyes = true;
              this.nach_flag_status = false;
              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;
              this.hidenachbutton = true;
              this.isEMandateCompleted = true;
              this.KFS_otp_send();
              setTimeout(() => {
                this.msgStepper_904 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_10021 = true;
              }, 700);
              setTimeout(() => {
                this.msgStepper_topup = true;
              }, 550);
              setTimeout(() => {
                this.msgStepper_10011 = true;
              }, 500);
            } else if (
              (this.nach_click == "Yes" || this.nach_click == "No") &&
              this.peenydrop == "REJECTED"
            ) {
              this.iscommupdated = true;
              this.isnachyes = true;
              this.nach_flag_status = false;
              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;
              this.hidenachbutton = true;

              this.isEMandateCompleted = false;
              this.isrejected = true;
              this.hidenachbutton = true;
              this.loader4 = false;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);

              this.ldsloader = false;
            } else if (this.nach_click == "No") {
              this.iscommupdated = true;
              this.nach_flag_status = false;
              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              setTimeout(() => {
                this.msg22 = true;
              }, 700);

              this.kyc_flag = true;
              this.ldsloader = false;
              this.hidenachbutton = true;
              this.non_existing_nach = true;
            } else if (this.oppid == "" && this.peenydrop == "APPROVED") {
              if (this.camp_category == "Top-Up") {
                this.get_Existing_Loan();
              }
              this.iscommupdated = true;
              this.nach_flag_status = false;
              this.isEMandateCompleted = false;
              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;
              this.loader4 = true;

              const body = {
                Mobile: sessionStorage.getItem("Mobile"),
              };
              this.service.exisiting_nach(body).subscribe(
                (res) => {},
                (error) => {
                  this.technicalerror = true;
                  this.loader4 = false;
                }
              );
            } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
              this.iscommupdated = true;
              this.isnachyes = true;
              this.nach_flag_status = false;
              setTimeout(() => {
                this.msg21 = true;
              }, 700);
              setTimeout(() => {
                this.msg22 = true;
              }, 700);
              this.isDisabled2 = true;
              this.kyc_flag = true;
              this.ldsloader = false;
              this.hidenachbutton = true;

              this.isEMandateCompleted = false;
              this.isrejected = true;
              this.hidenachbutton = true;
              this.loader4 = false;

              setTimeout(() => {
                this.msgStepper_1010 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1011 = true;
              }, 800);

              this.ldsloader = false;
            }
          } else {
            this.hidesubmit = false;
            this.iscommupdated = false;
            this.ishiddencom = false;

            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msg21 = false;
            }, 700);
            setTimeout(() => {
              this.msgStepper_904 = false;
            }, 700);
            this.ldsloader = false;
          }
        }
      } else {
        this.disablebutton = false;
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = true;
      this.hidediv = false;
    }
  }
  resumejourney4() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =
      this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;
    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);
    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
    this.MailingCountry ==
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;

    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.msgStepper_001 = true;
      this.istermsaccepted=true;
      this.msgStepper_0001 = true;
      this.is_Employement_submmited = true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.resumekyc = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
          this.deviceTrack();
      setTimeout(() => {
        this.msg8 = true;
      }, 1000);
      this.kycaddress = true;
      this.disablebutton = false;
      if (this.isContactupdated == false) {
        this.disableform = false;
        this.ishiddencom = false;
      } else {
        this.ishiddencom = true;
        this.disablebutton = true;

        this.addressrequired = true;
        setTimeout(() => {
          this.msg21 = true;
        }, 1000);
        setTimeout(() => {
          this.msgStepper_33 = true;
        }, 1000);
        this.residenceForm1.patchValue({
          flat: this.MailingStreet,
          postOffice: this.MailingCity,
          District: this.MailingCity,
          Pincode: this.MailingPostalCode,
          State: this.MailingState.toUpperCase(),
        });
        this.disableinput1 = true;

        if (this.kycstatus == "" || this.kycstatus == null) {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 1000);
          this.hidebutton2 = false;
          this.isDisabled = false;
        } else if (this.kycstatus == "Retry") {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 1000);
          this.hidebutton2 = false;
          this.isDisabled = false;
        } else if (this.kycstatus == "Failed") {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);

          setTimeout(() => {
            this.msgStepper_39 = false;
          }, 1000);
          this.hidebutton2 = false;
          this.isDisabled = false;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          setTimeout(() => {
            this.msgStepper_33 = true;
          }, 800);
          this.iscommupdated1 = true;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          this.isSelfie = true;
          setTimeout(() => {
            this.msg20 = true;
          }, 1000);
          this.hidebutton2 = true;
          this.nach_flag_status = true;
          setTimeout(() => {
            this.msgStepper_39 = true;
          }, 800);

          if (
            this.oppid != "" &&
            this.peenydrop == "APPROVED" &&
            this.rfc == "Success" &&
            (this.nachstatus == "success" || this.nachstatus == "Success")
          ) {
            if (this.camp_category == "Top-Up") {
              this.get_Existing_Loan();
            }

            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.isDisabled4 = false;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = true;
            this.KFS_otp_send();
            setTimeout(() => {
              this.msgStepper_904 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_10021 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_10011 = true;
            }, 500);
          } else if (
            this.peenydrop == "REJECTED" ||
            this.nachstatus == "Rejected" ||
            this.nachstatus == "REJECTED"
          ) {
            this.isEMandateCompleted = false;
            this.loader4 = false;

            this.isDisabled2 = true;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 800);
          } else if (this.oppid == "" && this.peenydrop == "APPROVED") {
            if (this.camp_category == "Top-Up") {
              this.get_Existing_Loan();
            }
            this.iscommupdated1 = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = false;
            this.kyc_flag = true;
            this.ldsloader = false;
          } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
            this.isEMandateCompleted = false;
            this.loader4 = false;

            this.isDisabled2 = true;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 800);
          } else {
            this.iscommupdated1 = true;
            this.nach_flag_status = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = false;
            this.kyc_flag = true;
            this.ldsloader = false;
          }
        }
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = true;
      this.hidediv = false;
    }
  }

  resumejourney5() {
    this.nachstatus = this.resumejourney.Data.NACH_Status;
    this.dedupestatus = this.resumejourney.Data.Dedupe_Status;
    this.Lid = this.resumejourney.Data.Lead_Id;
    this.kycstatus = this.resumejourney.Data.KYC_Status;
    this.isContactupdated =
      this.resumejourney.Data.Customer_Lead_Contact_Update;
    this.oppid = this.resumejourney.Data.Opportunity_Id;
    this.peenydrop = this.resumejourney.Data.Penny_Drop_Decision;
    this.rfc = this.resumejourney.Data.Ready_For_Conversion;
    this.LDSstatus = this.resumejourney.Data.LDS_Status;
    this.appid = this.resumejourney.Data.Application_ID;
    sessionStorage.setItem("Application_id", this.appid);
    this.firstname = this.resumejourney.Data.KYC_Existing_Data.FirstName;
    this.lastname = this.resumejourney.Data.KYC_Existing_Data.LastName;
    this.dob = this.resumejourney.Data.KYC_Existing_Data.Birthdate;
    this.MailingStreet =
      this.resumejourney.Data.KYC_Existing_Data.MailingStreet;
    this.MailingPostalCode =
      this.resumejourney.Data.KYC_Existing_Data.MailingPostalCode;
    this.MailingCity = this.resumejourney.Data.KYC_Existing_Data.MailingCity;
    this.MailingState = this.resumejourney.Data.KYC_Existing_Data.MailingState;
    this.MailingCountry =
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;
    this.addressverified =
      this.resumejourney.Data.Campaign.address_verify_button;
    this.kycbutton = this.resumejourney.Data.Campaign.kyc_button;
    this.nach_flag = this.resumejourney.Data.Campaign.NACH_flag__c;
    this.nach_click = this.resumejourney.Data.Campaign.nach_button;
    const body = {
      Mobile: this.User_Mobile,
    };
    this.service.nachdata(body).subscribe((res) => {
      this.Borrower_Name = res.Data.Borrower_Name__c;
      this.Borrower_Bank_Name = res.Data.Borrower_Bank_Name__c;
      this.Borrower_Account_Number = res.Data.Borrower_Account_Number__c;
      this.Borrower_IFSC = res.Data.Borrower_bank_IFSC_Number__c;
    });
    this.MailingCountry ==
      this.resumejourney.Data.KYC_Existing_Data.MailingCountry;

    if (this.dedupestatus == "Pre Approved" && this.Lid != "") {
      this.afterVerifedOTP = true;
      this.msgStepper_112 = true;
      this.otpverified = true;
      this.msgStepper_001 = true;
     this.msgStepper_0001=true
      this.is_Employement_submmited = true;
      this.istermsaccepted=true;
      this.msgStepper_002 = true;
      this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_003 = true;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.resumekyc = true;
      this.emp_type = this.resumejourney.Data.Employment_Type;
        this.employment_type = this.resumejourney.Data.Employment_Type;
        this.salary = this.resumejourney.Data.Monthly_Income;
        this.salary_mode = this.resumejourney.Data.Mode_Of_Income;
        this.purspose = this.resumejourney.Data.Loan_Purpose;
        this.householdincome1=this.resumejourney.Data.House_Hold_Income;
        this.monthlyIncome.patchValue({ salary:  this.salary });
        this.monthlyIncome.patchValue({salary_mode:  this.salary_mode });
  this.deviceTrack();
      setTimeout(() => {
        this.msg8 = true;
      }, 1000);
      this.kycaddress = true;
      this.disablebutton = false;

      if (this.isContactupdated == false) {
        this.disableform = false;
        this.ishiddencom1 = false;
      } else {
        this.ishiddencom = true;
        this.disablebutton = true;
        this.disableform = false;

        this.addressrequired = true;
        setTimeout(() => {
          this.msg21 = true;
        }, 1000);
        setTimeout(() => {
          this.msgStepper_33 = true;
        }, 1000);

        this.residenceForm1.patchValue({
          flat: this.MailingStreet,
          postOffice: this.MailingCity,
          District: this.MailingCity,
          Pincode: this.MailingPostalCode,
          State: this.MailingState.toUpperCase(),
        });

        if (this.kycstatus == "" || this.kycstatus == null) {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg21 = true;
          }, 1000);
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          this.resumekyc = true;
          this.disablebutton = true;

          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);

          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;

          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Retry") {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg21 = true;
          }, 1000);
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          this.resumekyc = true;
          this.disablebutton = true;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Failed") {
          this.iscommupdated1 = true;
          setTimeout(() => {
            this.msg21 = true;
          }, 1000);
          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          this.resumekyc = true;
          this.disablebutton = true;
          setTimeout(() => {
            this.msgStepper_34 = true;
          }, 1000);
          this.kycaddress = true;
          this.hideaddress = !this.hideaddress;
          setTimeout(() => {
            this.msgStepper_200 = true;
          }, 500);
          setTimeout(() => {
            this.msg8 = true;
          }, 500);
          this.hidebutton1 = !this.hidebutton1;
          this.nach_flag_status = false;
          this.isSelfie = false;
        } else if (this.kycstatus == "Rejected") {
          this.isKYCSuccess = false;
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else {
          setTimeout(() => {
            this.msgStepper_33 = true;
          }, 800);
          this.iscommupdated1 = true;

          setTimeout(() => {
            this.msg22 = true;
          }, 1000);
          this.isSelfie = true;
          setTimeout(() => {
            this.msg20 = true;
          }, 1000);
          this.hidebutton2 = true;
          this.nach_flag_status = false;
          setTimeout(() => {
            this.msgStepper_39 = true;
          }, 800);

          if (
            this.oppid == "" &&
            this.peenydrop == "" &&
            (this.nach_click == "Yes" || this.nach_click == null)
          ) {
            this.hidenachbutton = false;
            this.isDisabled2 = false;
          } else if (
            this.oppid != "" &&
            this.peenydrop == "APPROVED" &&
            (this.nach_click == "Yes" || this.nach_click == "No") &&
            (this.nachstatus == "success" || this.nachstatus == "Success")
          ) {
            if (this.camp_category == "Top-Up") {
              this.get_Existing_Loan();
            }
            this.isnachyes = true;
            this.hidenachbutton = true;
            setTimeout(() => {
              this.msg22 = true;
            }, 700);
            this.isDisabled2 = true;
            this.kyc_flag = true;
            this.ldsloader = false;
            this.isEMandateCompleted = true;
            this.KFS_otp_send();
            setTimeout(() => {
              this.msgStepper_904 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_10021 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_topup = true;
            }, 550);
            setTimeout(() => {
              this.msgStepper_10011 = true;
            }, 500);
          } else if (
            (this.peenydrop == "REJECTED" ||
              this.nachstatus == "Rejected" ||
              this.nachstatus == "REJECTED") &&
            (this.nach_click == "Yes" || this.nach_click == "No")
          ) {
            this.isrejected = true;
            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 700);
            this.hidenachbutton = true;
          } else if (this.nach_click == "No" && this.peenydrop == "") {
            this.hidenachbutton = true;
            this.non_existing_nach = true;
            this.isDisabled2 = false;
          } else if (this.peenydrop == "APPROVED" && this.rfc == "Failed") {
            this.isrejected = true;
            this.isEMandateCompleted = false;
            setTimeout(() => {
              this.msgStepper_1010 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_1011 = true;
            }, 700);
            this.hidenachbutton = true;
          } else {
            this.hidenachbutton = false;
          }
        }
      }
    } else if (this.dedupestatus == "Rejected") {
      this.counter = true;
      setTimeout(() => {
        this.msg100 = true;
      }, 500);
      setTimeout(() => {
        this.msg101 = true;
      }, 800);
    } else {
      this.resumeoffer = true;
      this.hidediv = false;
    }
  }

  enable: boolean = false;
  offeraccepted: boolean;

  offerdenied: boolean;
  kyc_flag: boolean;
  offerresetdenied: boolean;
  offerreset: boolean;
  isreset: boolean;
  sfdcEMI: any;
  msgStepper_selfie1: boolean;

  msg_105: Boolean;
  msg_106: Boolean;
  msg_107: Boolean;
  offerDenied() {
       //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Declined", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": this.offerAmount??"",    
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag":this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "Offer Denied",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});
    this.offerdenied = true;
    this.ishidden = !this.ishidden;
    this.ishidden1 = !this.ishidden1;
    this.ishidden2 = !this.ishidden2;

    this.hidediv = !this.hidediv;

    setTimeout(() => {
      this.msg_105 = true;
    }, 1300);
    setTimeout(() => {
      this.msg_106 = true;
    }, 2500);
    setTimeout(() => {
      this.msg_107 = true;
    }, 2900);
  }

  exitjourney: boolean;
  Denial_reason: any;
  Lead_id: any;

  thankuforVisit() {
    this.hideofferinterest = !this.hideofferinterest;
    this.offerrejection = true;
    this.Denial_reason = this.reasonForm.get("reason").value;
    
    this.webengage.track("Offer Declined Reason Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "Decline Reason":this.Denial_reason??"",
      "CPV Flag":this.stp_flag??""
    });


    const body = {
      Mobile: this.User_Mobile,
      Offer_Decision: "Reject",
      Reason: this.Denial_reason,
      Campaign_id: sessionStorage.getItem("Campaign_Id"),
    };

    this.service.postOfferDecision(body).subscribe((res) => {
      this.exitjourney = true;
      this.offerrejection = false;
      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Offer Denied Reason",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: this.Denial_reason,
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };

      this.service.getEventTrack(body1).subscribe((res) => {});
      setTimeout(() => {
        this.msg_107 = true;
      }, 1000);
    });
  }

  checkcallbackstatus() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.callback(body).subscribe(
      (res) => {
        this.kyc_decision_status = res.Data.KYC_Status;

        this.ContactId = res.Data.Contact_Id;
        this.sid = sessionStorage.getItem("Session ID");

        if (this.kyc_decision_status == "Approved") {         
          this.isretry = false;
          this.isDisabled = true;
          const body = {
            Contact_Id: this.ContactId,
          };

          this.service.kyc_callback(body).subscribe((res) => {
            this.kyc_decision = res["Data"];
            sessionStorage.setItem("Street", this.kyc_decision[0].Street);
            sessionStorage.setItem(
              "Post_Office",
              this.kyc_decision[0].Post_Office
            );
            sessionStorage.setItem("District", this.kyc_decision[0].District);
            sessionStorage.setItem("Pincode", this.kyc_decision[0].Pincode);
            sessionStorage.setItem("State", this.kyc_decision[0].State);
            this.isKYCSuccess = true;
            setTimeout(() => {
              this.msgStepper_403 = true;
            }, 500);
            setTimeout(() => {
              this.msgStepper_404 = true;
            }, 600);
            setTimeout(() => {
              this.msgStepper_405 = true;
            }, 700);
            setTimeout(() => {
              this.msgStepper_501 = true;
            }, 800);
            setTimeout(() => {
              this.msgStepper_506 = true;
            }, 900);
            this.flat = this.kyc_decision[0].Street;
            this.postOffice = this.kyc_decision[0].Post_Office;
            this.District = this.kyc_decision[0].District;
            this.Pincode = this.kyc_decision[0].Pincode;
            this.State = this.kyc_decision[0].State;
            this.residenceForm.patchValue({
              flat: this.kyc_decision[0].Street,
              landmark: this.kyc_decision[0].landmark || "",
              postOffice: this.kyc_decision[0].Post_Office,
              District: this.kyc_decision[0].District,
              Pincode: this.kyc_decision[0].Pincode,
              State: this.kyc_decision[0].State.toUpperCase(),
            });
          });

          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
        } else if (this.kyc_decision_status == "Rejected") {
          this.hide1 = !this.hide1;
          this.isKYCSuccess = false;
          this.isretry = false;
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isDisabled = true;
          setTimeout(() => {
            this.msg_61 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_62 = true;
          }, 800);
        } else if (this.kyc_decision_status == "Retry") {
          this.isKYCSuccess = false;
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isDisabled = false;
          this.isretry = true;
        } else if (this.kyc_decision_status == "Failed") {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isKYCSuccess = false;
          this.isDisabled = false;
        } else {
          this.count1 += 1;
          if (this.count1 <= 1500) {
            setTimeout(() => {
              this.checkcallbackstatus();
            }, 4000);
          } else {
            const body1 = {
              Request_Key: "",
              Mobile: this.User_Mobile,
              Event_Name: "Technical Error - KYC callback not received",
              Event_Type: "Button",
              Origin: "Frontend",
              Partner_Name: "DMI Finance",
              Remark_1: "",
              Remark_2: "",
              Remark_3: "",
              Remark_4: "",
              Remark_5: "",
            };
            this.service.getEventTrack(body1).subscribe((res) => {});
            this.isKYCSuccess = false;
            this.tryagain1 = true;
            clearInterval(this.checkDmiKYCWindowInterval);
            this.dmiKYCWindow.close();
            this.isDisabled = true;
            setTimeout(() => {
              this.msgStepper_1000 = true;
            }, 500);
            this.count1 = 0;
          }
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkcallbackstatus();
        }, 5000);

        return;
      }
    );
  }

  checkIfDmiKycClosed() {
    if (this.dmiKYCWindow?.closed) {
      this.isDisabled = false;
      clearInterval(this.checkDmiKYCWindowInterval);
    }
  }
  checkIfDmiKycClosed1() {
    if (this.dmiKYCWindow?.closed) {
      this.isDisabled2 = false;
      clearInterval(this.checkDmiKYCWindowInterval);
    }
  }
  checkIfDmiKycClosed2() {
    if (this.dmiKYCWindow?.closed) {
      this.isDisabled3 = false;
      clearInterval(this.checkDmiKYCWindowInterval);
    }
  }

  checkcallbackstatus3() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.callback(body).subscribe(
      (res) => {
        this.mandate_decision = res["Data"];

        if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Opportunity_Id != "" &&
          this.mandate_decision.Ready_For_Conversion == "Success" &&
          (this.mandate_decision.NACH_Status == "success" ||
            this.mandate_decision.NACH_Status == "Success")
        ) {
          this.loader4 = false;
          this.isEMandateCompleted = true;
          this.webengage.track("KFS Viewed", {
            "Campaign Type": this.camp_type??"",
            "Campaign Category": this.camp_category??"",
            "Campaign Sub Category": this.camp_sub_category??"",
            "Program Type": this.program_type??"",   
            "Sourcing Channel": this.sourcing_channel??"",     
            "Product Structure": this.prod_structure??"",
            "Product Name": this.prod_name??"",
            "Customer Segment": this.cust_segment??"",
             "Loan Amount":(this.GridAmount)?.toString()??"",
            "Loan EMI Amount":(this.GridEmi)?.toString()??"",
            "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
            "Lead Source":"X-Sell",
           "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
            "Household Income":(this.householdincome1?.toString())||"",
            "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
            "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
            "Employment Type":(this.emp_type||this.employment_type)??"",
            "Existing KYC Flag": this.kyc_webengage??"",
             "Existing Mandate Flag":this.nach??"",
            "Carry Forward Flag":this.carry_forward??"",
            "Insurance Amount":(this.insurance_premium1)??"",
             "CPV Flag":this.stp_flag??"",
            "Insurance Flag":this.insurance_flag1??""
      
          });
          this.KFS_otp_send();
         
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          setTimeout(() => {
            this.msgStepper_904 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_topup = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10011 = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10021 = true;
          }, 600);
          setTimeout(() => {
            this.msgStepper_10031 = true;
          }, 650);
        } else if (this.mandate_decision.NACH_Status == "Failure") {
          this.isEMandateCompleted = false;
          this.isDisabled2 = false;
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          setTimeout(() => {
            this.msgStepper_999 = true;
          }, 500);
        } else if (this.mandate_decision.Penny_Drop_Decision == "REJECTED") {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isEMandateCompleted = false;
          this.loader4 = false;

          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          return;
        } else if (
          this.mandate_decision.NACH_Status == "REJECTED" ||
          this.mandate_decision.NACH_Status == "Rejected"
        ) {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isEMandateCompleted = false;
          this.loader4 = false;

          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          return;
        } else if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Ready_For_Conversion == "Failed"
        ) {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          this.isEMandateCompleted = false;
          this.loader4 = false;

          setTimeout(() => {
            this.msgStepper_1010 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_1011 = true;
          }, 800);
          clearInterval(this.checkDmiKYCWindowInterval);
          this.dmiKYCWindow.close();
          return;
        } else {
          this.count += 1;

          if (this.count <= 1500) {
            setTimeout(() => {
              this.checkcallbackstatus3();
            }, 4000);
          } else {
            const body1 = {
              Request_Key: "",
              Mobile: this.User_Mobile,
              Event_Name: "Technical Error - Penny-Drop callback not received",
              Event_Type: "Button",
              Origin: "Frontend",
              Partner_Name: "DMI Finance",
              Remark_1: "",
              Remark_2: "",
              Remark_3: "",
              Remark_4: "",
              Remark_5: "",
            };
            this.service.getEventTrack(body1).subscribe((res) => {});
            this.isEMandateCompleted = false;
            this.tryagain = true;
            clearInterval(this.checkDmiKYCWindowInterval);
            this.dmiKYCWindow.close();
            setTimeout(() => {
              this.msgStepper_999 = true;
            }, 500);
            this.count = 0;
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkcallbackstatus3();
        }, 5000);

        return;
      }
    );
  }

  checknachcallbackstatus3() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.callback(body).subscribe(
      (res) => {
        this.mandate_decision = res["Data"];
        if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Opportunity_Id != "" &&
          this.mandate_decision.Ready_For_Conversion == "Success" &&
          (this.mandate_decision.NACH_Status == "success" ||
            this.mandate_decision.NACH_Status == "Success")
        ) {
          this.loader4 = false;
          this.isEMandateCompleted = true;
          this.webengage.track("KFS Viewed", {
            "Campaign Type": this.camp_type??"",
            "Campaign Category": this.camp_category??"",
            "Campaign Sub Category": this.camp_sub_category??"",
            "Program Type": this.program_type??"",   
            "Sourcing Channel": this.sourcing_channel??"",     
            "Product Structure": this.prod_structure??"",
            "Product Name": this.prod_name??"",
            "Customer Segment": this.cust_segment??"",
            "Loan Amount":(this.GridAmount)?.toString()??"",
            "Loan EMI Amount":(this.GridEmi)?.toString()??"",
            "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
            "Lead Source":"X-Sell",
           "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
            "Household Income":this.householdincome1?.toString()||"",
            "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
            "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
            "Employment Type":(this.emp_type||this.employment_type)??"",
            "Existing KYC Flag":this.kyc_webengage??"",
             "Existing Mandate Flag":this.nach??"",
            "Carry Forward Flag":this.carry_forward??"",
            "Insurance Amount":(this.insurance_premium1)??"",
             "CPV Flag":this.stp_flag??"",
            "Insurance Flag":this.insurance_flag1??""
      
          });
          this.KFS_otp_send();
          clearInterval(this.checkDmiKYCWindowInterval);
          setTimeout(() => {
            this.msgStepper_904 = true;
          }, 500);
          setTimeout(() => {
            this.msgStepper_topup = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10011 = true;
          }, 550);
          setTimeout(() => {
            this.msgStepper_10021 = true;
          }, 600);
          setTimeout(() => {
            this.msgStepper_10031 = true;
          }, 650);
        } else if (this.mandate_decision.NACH_Status == "Failure") {
          this.isEMandateCompleted = false;

          this.isDisabled2 = false;
          clearInterval(this.checkDmiKYCWindowInterval);

          setTimeout(() => {
            this.msgStepper_999 = true;
          }, 500);
        } else if (this.mandate_decision.Penny_Drop_Decision == "REJECTED") {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else if (
          this.mandate_decision.NACH_Status == "REJECTED" ||
          this.mandate_decision.NACH_Status == "Rejected"
        ) {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else if (
          this.mandate_decision.Penny_Drop_Decision == "APPROVED" &&
          this.mandate_decision.Ready_For_Conversion == "Failed"
        ) {
          clearInterval(this.checkDmiKYCWindowInterval);
          this.isrejected = true;
          return;
        } else {
          this.count_n += 1;

          if (this.count_n <= 1500) {
            setTimeout(() => {
              this.checknachcallbackstatus3();
            }, 4000);
          } else {
            const body1 = {
              Request_Key: "",
              Mobile: this.User_Mobile,
              Event_Name: "Technical Error - Penny-Drop callback not received",
              Event_Type: "Button",
              Origin: "Frontend",
              Partner_Name: "DMI Finance",
              Remark_1: "",
              Remark_2: "",
              Remark_3: "",
              Remark_4: "",
              Remark_5: "",
            };
            this.service.getEventTrack(body1).subscribe((res) => {});
            this.isEMandateCompleted = false;
            this.tryagain = true;
            clearInterval(this.checkDmiKYCWindowInterval);

            setTimeout(() => {
              this.msgStepper_999 = true;
            }, 500);
            this.count_n = 0;
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checknachcallbackstatus3();
        }, 5000);

        return;
      }
    );
  }
  LDS_decision;
  LDStatus;

  checkcallbackstatus4() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };
    this.service.callback(body).subscribe(
      (res) => {
        this.LDS_decision1 = res.Data;

        if (this.LDS_decision1.LDS_URL != "") {
          this.application_id = sessionStorage.getItem("Application_id");
          const body = {
            Application_Id: this.application_id,
          };

          this.service.afterlds(body).subscribe((res) => {
            if (res.Status == 200 && res.Message == "APP install success") {
              this.closeldsmodal.nativeElement.click();
              this.isDisabled5 = true;

              this.isLDSCompleted = true;
              this.ldsloader = false;
              this.Modelloader1 = false;

              setTimeout(() => {
                this.msgStepper_1004 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1005 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1006 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1101 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1102 = true;
              }, 500);
            } else if (
              res.Status == 200 &&
              res.Message == "Customer Already done App Install."
            ) {
              this.closeldsmodal.nativeElement.click();
              this.isDisabled5 = true;
              this.isLDSCompleted = true;
              this.ldsloader = false;
              this.Modelloader1 = false;
              setTimeout(() => {
                this.msgStepper_1004 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1005 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1006 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1101 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1102 = true;
              }, 500);
            } else {
              this.isDisabled5 = false;
            }
          });
        } else {
          this.count3 += 1;

          if (this.count3 <= 1500) {
            setTimeout(() => {
              this.checkcallbackstatus4();
            }, 3000);
          } else {
            this.isLDSCompleted = false;
            this.Modelloader1 = false;
            this.tryagain1 = true;
            setTimeout(() => {
              this.msgStepper_999 = true;
            }, 500);
            this.count3 = 0;
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkcallbackstatus5();
        }, 5000);

        return;
      }
    );
  }
  checkcallbackstatus5() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };
    this.service.callback(body).subscribe(
      (res) => {
        this.LDS_decision1 = res.Data;

        if (this.LDS_decision1.LDS_URL != "") {
          this.application_id = sessionStorage.getItem("Application_id");
          const body = {
            Application_Id: this.application_id,
          };

          this.service.afterlds(body).subscribe((res) => {
            if (res.Status == 200 && res.Message == "APP install success") {
              this.isLDSCompleted = true;
              this.ldsloader = false;
              this.hideldsloader = !this.hideldsloader;
              setTimeout(() => {
                this.msgStepper_1004 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1005 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1006 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1101 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1102 = true;
              }, 500);
            } else if (
              res.Status == 200 &&
              res.Message == "Customer Already done App Install."
            ) {
              this.isLDSCompleted = true;
              this.ldsloader = false;
              this.hideldsloader = !this.hideldsloader;
              setTimeout(() => {
                this.msgStepper_1004 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1005 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1006 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1101 = true;
              }, 500);
              setTimeout(() => {
                this.msgStepper_1102 = true;
              }, 500);
            } else {
              this.ldsloader = true;
            }
          });
        } else {
          this.count3 += 1;

          if (this.count3 <= 1500) {
            setTimeout(() => {
              this.checkcallbackstatus5();
            }, 3000);
          } else {
            this.isLDSCompleted = false;
            this.ldsloader = false;
            this.tryagain1 = true;
            setTimeout(() => {
              this.msgStepper_999 = true;
            }, 500);
            this.count3 = 0;
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkcallbackstatus5();
        }, 5000);

        return;
      }
    );
  }

  hidebutton: boolean = false;

  kycModal(event) {
    if (event == 1) {
      this.isDisabled = true;

       
      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Proceed For KYC",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };

      this.service.getEventTrack(body1).subscribe((res) => {});    

      const body = {
        Service_Name: "KYC",
        Mobile: this.User_Mobile,
      };

      this.service.getKYCurl(body).subscribe((res) => {
        if (res.Status == 200) {
          this.dynamicURL = res["Data"];

          const width = screen.width * 0.62 < 400 ? 400 : screen.width * 0.62;
          const height = screen.height * 0.62;
          const left = screen.width / 2 - width / 2;
          const top = screen.height / 2 - height / 2;
          this.dmiKYCWindow = window.open(
            this.dynamicURL,
            "_blank",
            ",scrollbars=1,menubar=0,resizable=1,width = " +
              width +
              ", height = " +
              height +
              ", top = " +
              top +
              ", left = " +
              left
          );
            //Richa Pathak
    //18/03/2025
    this.webengage.track("New KYC Initiated", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",     
      "Loan Amount": parseInt(this.GridAmount)??"",
      "Loan EMI Amount":(this.GridEmi)?.toString()??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
      "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":parseInt(this.householdincome1)??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":parseInt(this.Salary_amount||this.salary)??"",      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Udhyam Registered":"",
      "KYC Type":"Digilocker/EKYC",        
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag

    });


          this.checkDmiKYCWindowInterval = setInterval(() => {
            this.checkIfDmiKycClosed();
          }, 300);

          this.checkcallbackstatus();
        } else {
          this.tryagain1 = true;
          this.isKYCSuccess = false;

          setTimeout(() => {
            this.msgStepper_1000 = true;
          }, 500);
        }
      });
    }

    if (event == 3) {
      this.isDisabled2 = true;
      this.webengage.track("e-Mandate Setup Initiated", {
        "Campaign Type": this.camp_type??"",
        "Campaign Category": this.camp_category??"",
        "Campaign Sub Category": this.camp_sub_category??"",
        "Program Type": this.program_type??"",   
        "Sourcing Channel": this.sourcing_channel??"",     
        "Product Structure": this.prod_structure??"",
        "Product Name": this.prod_name??"",
        "Customer Segment": this.cust_segment??"", 
        "Offer Amount": parseInt(this.offerAmount)??"", 
        "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",   
        "Loan Amount": (this.GridAmount)?.toString()??"",   
        "Loan EMI Amount":(this.GridEmi)?.toString()??"",
        "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
        "Lead Source":"X-Sell",
       "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
        "Household Income":(this.householdincome1)?.toString()??"",
        "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
        "Monthly Income":(this.Salary_amount||this.salary)?.toString()??"" ,      
        "Employment Type":(this.emp_type||this.employment_type)??"",
        "Existing KYC Flag": this.kyc_webengage??"",
        "Existing Mandate Flag":this.nach??"",
        "Carry Forward Flag":this.carry_forward??"",
        "CPV Flag":this.stp_flag??""
  
      });
      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Proceed For E-mandate",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };

      this.service.getEventTrack(body1).subscribe((res) => {});

      const body = {
        Service_Name: "E-mandate",
        Mobile: this.User_Mobile,
      };

      this.service.getKYCurl(body).subscribe((res) => {
        this.dynamicURL = res["Data"];
        const width = screen.width * 0.62 < 400 ? 400 : screen.width * 0.62;
        const height = screen.height * 0.62;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        this.dmiKYCWindow = window.open(
          this.dynamicURL,
          "_blank",
          ",scrollbars=1,menubar=0,resizable=1,width = " +
            width +
            ", height = " +
            height +
            ", top = " +
            top +
            ", left = " +
            left
        );
        this.checkDmiKYCWindowInterval = setInterval(() => {
          this.checkIfDmiKycClosed1();
        }, 300);
        this.get_Existing_Loan();
        this.checkcallbackstatus3();
      });
    }
    if (event == 4) {
      this.Modelloader1 = true;
      // this.otp_input=false;
      this.ldsloader = true;
      this.isDisabled3 = true;
      this.isDisabled4 = true;
      this.loader1 = true;
      this.hidebutton7 = !this.hidebutton7;
      this.disablecheckbox = false;
      this.disableldsaccept = true;
      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "View LDS",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };
      this.service.getEventTrack(body1).subscribe((res) => {});
      const body = {
        Service_Name: "LDS",
        Mobile: this.User_Mobile,
      };

      this.service.getKYCurl(body).subscribe((res) => {
        this.ldsloader = false;
        this.loader1 = false;
        // this.response = res.Data;
        // Dynamic KFS
        this.response1 = res;
        this.response = this.response1.Data.Template;

        this.lafdata = this.response.LAF;
        this.Modelloader1 = false;
      });
    }

    if (event == 5) {
      this.isDisabled4 = true;
      this.otp_input = true;      
      setTimeout(() => {
        this.msgStepper_10031 = true;
      }, 650);
      this.ldsloader = true;
      this.isDisabled4 = true;
      this.isDisabled3 = true;
      this.isDisabled5 = true;
      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Proceed For LDS",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };
      this.service.getEventTrack(body1).subscribe((res) => {});

      this.Mobile = sessionStorage.getItem("Mobile");

      this.application_id = sessionStorage.getItem("Application_id");
      var today = new Date();
      var hour = today.getHours();
      var min = today.getMinutes();
      var sec = today.getSeconds();
      var currenttime = hour + ":" + min + ":" + sec;
      var transformDate = this.datePipe.transform(today, "yyyy-MM-dd");
      this.timestamp = transformDate + " " + currenttime;
      const body = {
        Mobile: this.Mobile,
        LDS_OTP_Signature: "",
        LDS_OTP_Request_Time_Stamp: this.timestamp,
        LDS_OTP_Verify_Time_Stamp: "",
      };

      this.service.directlds(body).subscribe((res) => {
        if (res.Status == 200) {
          this.checkcallbackstatus5();
        }
      });
    }

    // Curing Emandate Call
    if (event == 6) {
      this.isDisabled2 = true;

      const body1 = {
        Request_Key: "",
        Mobile: this.User_Mobile,
        Event_Name: "Proceed For Re-mandate",
        Event_Type: "Button",
        Origin: "Frontend",
        Partner_Name: "DMI Finance",
        Remark_1: "",
        Remark_2: "",
        Remark_3: "",
        Remark_4: "",
        Remark_5: "",
      };

      this.service.getEventTrack(body1).subscribe((res) => {});

      const body = {
        Service_Name: "Emandate_Curing",
        Mobile: this.User_Mobile,
      };

      this.service.getKYCurl(body).subscribe((res) => {
        this.dynamicremandateURL = res["Data"];
        const width = screen.width * 0.62 < 400 ? 400 : screen.width * 0.62;
        const height = screen.height * 0.62;
        const left = screen.width / 2 - width / 2;
        const top = screen.height / 2 - height / 2;
        this.dmiCuringWindow = window.open(
          this.dynamicremandateURL,
          "_blank",
          ",scrollbars=1,menubar=0,resizable=1,width = " +
            width +
            ", height = " +
            height +
            ", top = " +
            top +
            ", left = " +
            left
        );
        this.checkDmiCuringWindowInterval = setInterval(() => {
          this.checkIfDmiCuringClosed();
        }, 300);

        this.checkDmiCuringCallback();
      });
    }
  }

  //Curing callback check
  checkDmiCuringCallback() {
    const body = {
      Mobile: sessionStorage.getItem("Mobile"),
    };

    this.service.callback(body).subscribe(
      (res) => {
        this.mandate_decision = res["Data"].Curing_Status;
        // console.log(this.mandate_decision)

        if (
          this.mandate_decision.NACH_Status == "success" ||
          this.mandate_decision.NACH_Status == "Success"
        ) {
          clearInterval(this.checkDmiCuringWindowInterval);
          this.dmiCuringWindow.close();
          this.iscuringEMandateCompleted = true;
          setTimeout(() => {
            this.msgStepper_curing_904 = true;
          }, 500);
        } else if (
          this.mandate_decision.NACH_Status == "REJECTED" ||
          this.mandate_decision.NACH_Status == "Rejected"
        ) {
          clearInterval(this.checkDmiCuringWindowInterval);
          this.dmiCuringWindow.close();
          this.iscuringEMandateCompleted = false;
          setTimeout(() => {
            this.msgStepper_curing_1010 = true;
          }, 500);
        } else {
          this.count += 1;

          if (this.count <= 1500) {
            setTimeout(() => {
              this.checkDmiCuringCallback();
            }, 4000);
          } else {
            const body1 = {
              Request_Key: "",
              Mobile: this.User_Mobile,
              Event_Name: "Technical Error - Curing callback not received",
              Event_Type: "Button",
              Origin: "Frontend",
              Partner_Name: "DMI Finance",
              Remark_1: "",
              Remark_2: "",
              Remark_3: "",
              Remark_4: "",
              Remark_5: "",
            };
            this.service.getEventTrack(body1).subscribe((res) => {});
            clearInterval(this.checkDmiCuringWindowInterval);
            this.dmiCuringWindow.close();
          }

          return;
        }
      },
      (err) => {
        setTimeout(() => {
          this.checkcallbackstatus3();
        }, 5000);

        return;
      }
    );
  }
  checkIfDmiCuringClosed() {
    if (this.dmiCuringWindow?.closed) {
      this.isDisabled = false;
      clearInterval(this.checkDmiCuringWindowInterval);
    }
  }

  Modelloader1: boolean = false;
  oncheckclick(event: any) {
    if (event.checked == true) {
      this.disableldsaccept = false;
    } else {
      this.disableldsaccept = true;
    }
  }

  onldsAccept() {
    // this.Modelloader1 = true;    
    const body1 = {
      Request_Key: "",
      Mobile: this.User_Mobile,
      Event_Name: "View & Accept LDS",
      Event_Type: "Button",
      Origin: "Frontend",
      Partner_Name: "DMI Finance",
      Remark_1: "",
      Remark_2: "",
      Remark_3: "",
      Remark_4: "",
      Remark_5: "",
    };
    this.service.getEventTrack(body1).subscribe((res) => {});

    this.closeldsmodal.nativeElement.click();
    // this.Mobile = sessionStorage.getItem('Mobile');

    // this.application_id = sessionStorage.getItem('Application_id')
    // var today = new Date;
    // var hour = today.getHours();
    // var min = today.getMinutes();
    // var sec = today.getSeconds();
    // var currenttime = hour + ":" + min + ":" + sec;
    // var transformDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    // this.timestamp = transformDate + ' ' + currenttime;
    // const body = {
    //   Mobile: this.Mobile, LDS_OTP_Signature: '', LDS_OTP_Request_Time_Stamp: this.timestamp, LDS_OTP_Verify_Time_Stamp: ''

    // }
    // this.service.directlds(body).subscribe(res => {
    //   if (res.Status == 200) {

    //     this.checkcallbackstatus4();

    //   }
    // })
  }

  get_Existing_Loan() {
    const body = {
      Mobile: sessionStorage.getItem('Mobile'),
    };
    // console.log(body,'existingloan')
    this.service.getExistingLoan(body).subscribe((res) => {
      this.outstanding = res.Data.Current_Total_Outstanding;
      this.topupamount = this.offerAmount - this.outstanding;
      this.topupamount1 = Intl.NumberFormat("en-IN").format(this.topupamount);     
      if(this.camp_category == "Top-Up") {
      //  Topup PF Calculation
      this.processingFeeValue = Math.min(this.processingFeePercentage * this.topupamount, 6000);
      // console.log(this.processingFeeValue)
       this.pfgst=(this.processingFeeValue * 1.18).toFixed(2)
      this.processing_fee1 = Intl.NumberFormat("en-IN").format(
        this.pfgst
      );
      const body1 = {
        Application_ID: sessionStorage.getItem("Application_id"),
        Processing_Fees_GST__c:(this.processingFeeValue * 1.18).toFixed(2)
      };
      this.service.update_PF(body1).subscribe((res) => {});
       this.disburseamount = this.topupamount - (Math.round(this.processingFeeValue * 1.18)) 
      this.disburseamount1 = Intl.NumberFormat("en-IN").format(
        this.disburseamount
      );
    }
    });

   
    
  }
  insurance_unchecked(e) {
// console.log(e.target.checked,'vjhjh')

    if (e.target.checked == false) {
      this.insurance_opted = false;
      // console.log(this.insurance_opted ,'insurance_opted')
      
      this.netdisbusedamount = this.GridAmount - this.GridProcessingFee;
     
    
    
    } else {
      this.insurance_opted = true;
      this.netdisbusedamount =
        this.GridAmount - this.GridProcessingFee - this.insurance_premium;
    }
  }
  errorsubmit: boolean = false;
  onInsuranceconfirm() {
     this.webengage.track("KFS Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": (this.GridAmount)?.toString()??"",   
      "Loan EMI Amount":(this.GridEmi)?.toString()??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1)?.toString()??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)?.toString()??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag":this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Insurance Amount":this.insurance_premium1||"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":this.insurance_flag1??""

    });
    if (this.promoapplicable == true && this.promoapplied == true) {
      if (this.promocode != "") {
        const BODY = {
          Application_ID: sessionStorage.getItem("Application_id"),
          Coupon_Name: this.promocode,
        };
        this.service.submitpromocode(BODY).subscribe({
          next: (res) => {
            this.isdetailsconfirmed = true;
            this.insurancedisablecheckbox = true;
           

            const body = {
              Application_ID: sessionStorage.getItem("Application_id"),
              request_insurance_loan: this.insurance_opted,
            };
            this.service.setInsurance(body).subscribe((res) => {});
            // if(this.insurance_opted=true)
            //   {
            //     this.isSkipInsurance=true
            //   }
          },
          error: (err) => {
            if (err.status == 404 || err.Status == 404) {
              this.errorsubmit = true;
            }
          },
        });
      } else if (this.promocode == "") {
        const BODY = {
          Application_ID: sessionStorage.getItem("Application_id"),
          Coupon_Name: this.promocode1,
        };
        this.service.submitpromocode(BODY).subscribe({
          next: (res) => {
            this.isdetailsconfirmed = true;
            this.insurancedisablecheckbox = true;
            // if(this.insurance_opted=true)
            //   {
            //     this.isSkipInsurance=true
            //   }

            const body = {
              Application_ID: sessionStorage.getItem("Application_id"),
              request_insurance_loan: this.insurance_opted,
            };
            this.service.setInsurance(body).subscribe((res) => {});
          },
          error: (err) => {
            if (err.status == 404 || err.Status == 404) {
              this.errorsubmit = true;
            }
          },
        });
      }
    } else {
      this.isdetailsconfirmed = true;
      if(this.insurance_opted==true)
      {
        this.isSkipInsurance=true
      }
      this.insurancedisablecheckbox = true;
      // if(this.insurance_opted=true)
      //   {
      //     this.isSkipInsurance=true
      //   }

      const body = {
        Application_ID: sessionStorage.getItem("Application_id"),
        request_insurance_loan: this.insurance_opted,
      };
      this.service.setInsurance(body).subscribe((res) => {});
    }
  }
  showinsurancedoc() {
    window.open(this.docurl);
  }

  // KFS Esign
  KFS_otp_send() {
    this.startOtpTimer();
    // this.isDisabled5 = true;
    this.isDisabled4 = true;
    const body = {
      Application_ID: this.Application_id,
    };

    this.service.sendKFSOTP(body).subscribe(
      (res) => {
        this.webengage.track("KFS OTP Viewed", {
          "Campaign Type": this.camp_type??"",
          "Campaign Category": this.camp_category??"",
          "Campaign Sub Category": this.camp_sub_category??"",
          "Program Type": this.program_type??"",   
          "Sourcing Channel": this.sourcing_channel??"",     
          "Product Structure": this.prod_structure??"",
          "Product Name": this.prod_name??"",
          "Customer Segment": this.cust_segment??"",
          "Loan Amount": (this.GridAmount)?.toString()??"",   
          "Loan EMI Amount":(this.GridEmi)?.toString()??"",
          "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
          "Lead Source":"X-Sell",
         "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
          "Household Income":(this.householdincome1?.toString())??"",
          "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
          "Monthly Income":parseInt(this.Salary_amount||this.salary)??"" ,      
          "Employment Type":(this.emp_type||this.employment_type)??"",
          "Existing KYC Flag": this.kyc_webengage??"",
          "Existing Mandate Flag":this.nach??"",
          "Carry Forward Flag":this.carry_forward??"",
          "Insurance Amount":(this.insurance_premium1)??"",
          "CPV Flag":this.stp_flag??"",
          "Insurance Flag":this.insurance_flag1??""
    
        });
        this.response=res
        this.Request_id =  this.response.Data.data.request_id;
      },
      (error) => {
        this.isDisabled = false;
      }
    );
  }

  KFS_otp_verify(otp) {
    this.Errormessage = "";
    this.webengage.track("KFS OTP Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
       "Loan Amount": (this.GridAmount)?.toString()??"",   
       "Loan EMI Amount":(this.GridEmi)?.toString()??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1?.toString())??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":parseInt(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
    " Insurance Amount":(this.insurance_premium1)??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":(this.insurance_flag)?.toString()??""

    });
    if (otp.length == 4) {
      const body = {
        Application_ID: this.Application_id,
        Request_ID: this.Request_id,
        KFS_OTP: otp,
      };
      this.service.verifyKFSOTP(body).subscribe(
        (res) => {
          //  this.disableOtpInput();
          this.isDisabled4 = false;
          this.kfsotpverified = true;
          this.webengage.track("KFS Successful", {            
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
         "Loan Amount": (this.GridAmount)?.toString()??"",   
          "Loan EMI Amount":(this.GridEmi)?.toString()??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1?.toString())??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)?.toString()??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "Insurance Amount":(this.insurance_premium1)??"",
      "Disbursal Message":this.message??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":(this.insurance_flag1)??""


    });   
          
          this.resend_OTP1;
          //  console.log('this.kfsotpverified',this.kfsotpverified)
          const otpInputElements = document.querySelectorAll("input.otp-input");
          otpInputElements.forEach((input) => {
            this.renderer.setAttribute(input, "readonly", "true");
          });
          //  this.disableOtpInput();
          this.updateConfig1();
         
        },
        (error) => {
          this.otperror = true;
          this.Errormessage = "Invalid OTP";
          const body = {
            Request_Key: "",
            Mobile: this.User_Mobile,
            Event_Name: "OTP not verified",
            Event_Type: "API",
            Origin: "Frontend",
            Partner_Name: "DMI Finance",
            Remark_1: error,
            Remark_2: "",
            Remark_3: "",
            Remark_4: "",
            Remark_5: "",
          };
          this.service.getEventTrack(body).subscribe((res) => {});
        
          this.updateConfig();
          
        }
      );
    } else {
      this.isDisabled4 = true;
      return;
    }
  }

  otpControl = new FormControl({ value: "", disabled: true });
  updateConfig() {
    this.config1 = {
      allowNumbersOnly: true,
      length: 4,
      isPasswordInput: false,
      disableAutoFocus: false,
      placeholder: "",
      inputClass: "otp-input",

      inputStyles: {
        border: "1px solid red",
        outline: "none",
        "border-top": "1px solid #b7b5b5",
        "border-left": "1px solid #b7b5b5",
        "border-right": "1px solid #b7b5b5",
        "margin-bottom": "20px",
        "margin-top": "20px",
        height: "40px",
        width: "100",
      },
    };
  }
  updateConfig1() {
    this.config1 = {
      allowNumbersOnly: true,
      length: 4,
      isPasswordInput: false,
      disableAutoFocus: false,
      placeholder: "",
      inputClass: "otp-input",
      inputStyles: {
        border: "1px solid black",
        outline: "none",
        "border-top": "1px solid #b7b5b5",
        "border-left": "1px solid #b7b5b5",
        "border-right": "1px solid #b7b5b5",
        "margin-bottom": "20px",
        "margin-top": "20px",
        height: "40px",
        width: "100",
      },
    };
  }
  //  For Disable OTP input when otp verify
  // disableOtpInput() {
  //   const inputs = this.otpInput?.nativeElement.querySelectorAll('input'); // Access all input fields
  //   inputs.forEach((input: HTMLInputElement) => {
  //     input.disabled = true; // Disable each input field
  //     input.style.backgroundColor = '#e0e0e0'; // Optional: Change background color to indicate disabled state
  //   });
  // }

  startOtpTimer() {
    this.showTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.resend_OTP = true;
        this.showTimer = false;
      } else {
        this.timeLeft = 60;
        this.resend_OTP = false;
      }
    }, 1000);
    this.timeLeft = 60;
    this.showTimer = true;
    this.resend_OTP = false;
  }
  onTopupconfirm() {
    this.webengage.track("KFS Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1?.toString()??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":parseInt(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "Insurance Amount":(this.insurance_premium1)??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":(this.insurance_flag1)?.toString()??""

    });
    this.istopupcardConfirmed = true;
    this.isdetailsconfirmed = false;
    if (this.topuppromoapplied == true && this.promocode != "") {
      const BODY = {
        Application_ID: sessionStorage.getItem("Application_id"),
        Coupon_Name: this.topuppromocode,
      };
      this.service.submitpromocode(BODY).subscribe({
        next: (res) => {
          this.isdetailsconfirmed = true;
          this.insurancedisablecheckbox = true;
          this.isSkipInsurance=true

          const body = {
            Application_ID: sessionStorage.getItem("Application_id"),
            request_insurance_loan: this.insurance_opted,
          };
          this.service.setInsurance(body).subscribe((res) => {});
        },
        error: (err) => {
          if (err.status == 404 || err.Status == 404) {
            this.errorsubmit = true;
          }
        },
      });
    } else {
      this.onTopupcardconfirm();
    }
  }

  onTopupcardconfirm() {
    this.isdetailsconfirmed = true;
    this.istopupcardConfirmed = true;
    this.applydisable1 = true;
    this.applydisable = true;
    this.applydisable1 = true;
   this.isSkipInsurance=true
  }

  //PA Journey

onTermsAccept()
{
    //Richa Pathak
    //18/03/2025
    this.webengage.track("Application TnC Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": this.offerAmount??"",    
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
      "Existing KYC Flag":this.kyc_webengage??"",
      "Existing Mandate Flag":(this.nach)?.toString()??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });



  this.istermsaccepted=true;
  this.msgStepper_0001=true

  var today = new Date();
  var hour = today.getHours();
  var min = today.getMinutes();
  var sec = today.getSeconds();
  var currenttime = hour + ":" + min + ":" + sec;
  var transformDate = this.datePipe.transform(today, "yyyy-MM-dd");
  this.timestamp_terms_acceptance = transformDate+'T'+ currenttime+'.000'+'+05:30';
  // console.log(this.timestamp_terms_acceptance)
}



  onSelectmployement(event) {
    //  console.log(event.value,'emply type')
    this.employment_type = event.value;
    this.employment_submitted = true;
  }
  OnSubmitEmployement() {
    //Richa Pathak
    //18/03/2025
    this.webengage.track("Employment Profile Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": parseInt(this.offerAmount)??"",    
      "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });

    if (this.employment_type == "" || this.employment_type == undefined) {
      return;
    } else {
      this.is_Employement_submmited = true;
      this.msgStepper_001 = true;
    }
  }

  onSelecttransactionmode(event) {

    

    this.transaction_mode = this.monthlyIncome.get('salary_mode').value
    // console.log(this.transaction_mode);
  }

  onSubmitTransactionMode() {
   
    this.Salary_amount = this.monthlyIncome.get('salary').value
    //  console.log(this.Salary_amount);
    //  this.isHouseHoldIncomeEnable$.next(true);

    // console.log(this.transaction_mode)
      //Richa Pathak
    //18/03/2025
    this.webengage.track("Income Details Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": this.offerAmount??"",    
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,   
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":(this.nach)?.toString()??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""
    });


    if (
      this.Salary_amount == "" ||
      this.transaction_mode == "" ||
      this.transaction_mode == undefined
    ) {
      return;
    } else {
      if(this.Salary_amount<25000)
      {
        if(this.Salary_amount<1000)
        {
          this.showsalaryerror=true;
          return;
        }
        else
        {
          this.showsalaryerror=false
        }
      
        this.showHouseholdincome=true;
        this.is_transaction_mode_submitted = true;
        this.is_salary_amount_submitted = true;
        this.msgStepper_002 = true;
      }
      else{
        this.showHouseholdincome=false
        this.is_transaction_mode_submitted = true;
      this.is_salary_amount_submitted = true;
      this.msgStepper_002 = true;
      this.showsalaryerror=false;
      }
      
    }
  }

  onSelectloanpurpose(event) {
    this.loan_purspose = event.value;
  }
  OnSubmitRequiredLoanamount() {
    if (this.loan_purspose == "" || this.loan_purspose == undefined) {
      return;
    } else {
      
      this.required_loan_amount = this.required_loan;
      this.is_loan_purpose = true;
      this.is_loan_amount = true;
      this.msgStepper_003 = true;
      //Richa Pathak
    //18/03/2025
    this.webengage.track("Loan Purpose Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": this.offerAmount??"",    
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1)?.toString()||"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,     
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":(this.nach)?.toString()||"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });

       //Richa Pathak
    //18/03/2025
    this.webengage.track("Offer Page Viewed", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": parseInt(this.offerAmount)??"",    
      "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1?.toString()) || "",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,     
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
    }
   }
  // Compilance changes End 
  // Richa Pathak 
  // Date 9-01-2025 
  formatCurrency(value: any) {
    value = String(value).replace(/₹/, "").replace(/\,/g, "");
    value = value.toString();
    if (value && !isNaN(value)) {
      let num = parseInt(value);
      let result = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
      }).format(Number(num));
    //  console.log(result)
      this.monthlyIncome.patchValue({ salary: result });

    }
  }

 formatCurrency1(value: any) {
    value = String(value).replace(/₹/, "").replace(/\,/g, "");
    value = value.toString();
    if (value && !isNaN(value)) {
      let num = parseInt(value);
      let result = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
      }).format(Number(num));
    //  console.log(result)
      this.householdIncome.patchValue({ householdincome: result });
      
    }
  }



  onSubmithousehold()
  {
   
    // console.log(this.householdincome,'hhincome').
    //update house hold income 
   

    this.householdincome1= this.householdIncome.get("householdincome").value
      //Richa Pathak
    //18/03/2025
    this.webengage.track("Household Income Details Submitted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Offer Amount": parseInt(this.offerAmount)??"",    
      "Offer Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":this.emp_type ??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
    if(parseInt(this.householdincome1)<25000)
    {
      if(parseInt(this.householdincome1)<1000)
       {
        this.showerrormsg=true
        this.msg="Income should be greater than ₹1000"
        return;
      }
      else if(parseInt(this.householdincome1)<parseInt(this.Salary_amount))
      {
        this.showerrormsg=true
        this.msg="Household Income should be greater than Individual Income"
        return;
      }
      else if(parseInt(this.householdincome1)>=parseInt(this.Salary_amount)){     
      this.isHouseholdincomesubmitted=true;
      this.showerrormsg=false
      this.msg=""
      this.submitHouseholdincome()
      }
    }
    else{
      this.showerrormsg=false
      this.msg=""
      this.isHouseholdincomesubmitted=true
      this.ishouseholdgreater=true
      this.msg_1008=true;

    }
     

  }
  
submitHouseholdincome()
{
    //Richa Pathak
    //18/03/2025
    this.webengage.track("Rejection Page Viewed", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag":this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
  this.BODY = {
    Mobile: this.User_Mobile,
    Offer_Decision: "Accept",
    Reason: "",
    Campaign_id: sessionStorage.getItem("Campaign_Id"),
    Loan_Emi: this.emi[this.selectedId],
    Loan_Tenor: this.tenorOptions[this.selectedId],
    Proceesing_Fees:  this.processing_fee_withoutgst ,
    Loan_Amount: this.gridsize,
    Loan_Roi: this.rateOfInterest[this.selectedId],
    Processing_Fees_GST:  this.processing_fee ,
    EmploymentType: this.employment_type,
    Required_Amount: "",
    Monthly_Income: this.Salary_amount,
    Mode_Of_Income: this.transaction_mode,
    Loan_Purpose: this.loan_purspose,
    Other_Loan_Purpose: this?.required_loan_amount ?? "",
    House_Hold_Income:this.householdincome1,
    Timestamp:this.timestamp_terms_acceptance
  };
this.service.postOfferDecision(this.BODY).subscribe(
  (res) => {
       
  },
  (error) => {
    // console.log(JSON.parse(decryptString(error, this.secretkey)))
    // console.log(error.error.Message)
   
  }
);

}
async showLoanUndertaking()
{
  window.open("https://www.dmifinance.in/loan-application-undertaking-english/",'_blank');
}

inbound()
{
   //Richa Pathak
    //18/03/2025
    this.webengage.track("Inbound Call Initiated", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Offer Annualized Interest Rate in %": this.ROIAnnually??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":this.householdincome1??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??""

    });
}

  onSubmitGetDmiFinanceApp() {

    window.location.href="https://play.google.com/store/apps/details?id=in.dmifinance.app&pcampaignid=web_share&utm_source=bot_pa"
  }


  isSkipInsurance:boolean=false
  onSkipInsurance()
  {
    this.isSkipInsurance=true;
      const body1 = {
            Request_Key: "",
            Mobile: sessionStorage.getItem("MobileNumber"),
            Event_Name: "Nudge Insurance opted-out",
            Event_Type: "API",
            Origin: "Frontend",
            Partner_Name: "DMI Finance",
            Remark_1: "",
            Remark_2: "",
            Remark_3: "",
            Remark_4: "",
            Remark_5: "",
          };

          this.service.getEventTrack(body1).subscribe((res) => {});
  }

  isInsuranceAdded:boolean=false
  onaddingInsurance()
  {
    this.isInsuranceAdded=true
  }
  isFingoldconfirmed:boolean=false;
  onInsuranceconfirm1() {
    this.isInsuranceAdded=true
     this.netdisbusedamount=this.GridAmount - this.GridProcessingFee - this.insurance_premium;
    this.webengage.track("KFS Accepted", {
      "Campaign Type": this.camp_type??"",
      "Campaign Category": this.camp_category??"",
      "Campaign Sub Category": this.camp_sub_category??"",
      "Program Type": this.program_type??"",   
      "Sourcing Channel": this.sourcing_channel??"",     
      "Product Structure": this.prod_structure??"",
      "Product Name": this.prod_name??"",
      "Customer Segment": this.cust_segment??"",
      "Loan Amount": parseInt(this.GridAmount)??"",   
      "Loan EMI Amount":parseInt(this.GridEmi)??"",
      "Loan Annualized Interest Rate in %": parseInt(this.ROIAnnually)??"",
      "Lead Source":"X-Sell",
     "Purpose of Loan":(this.loan_purspose||this.purspose)??"",
      "Household Income":(this.householdincome1)?.toString??"",
      "Mode of Payment":(this.transaction_mode||this.salary_mode)??"",
      "Monthly Income":(this.Salary_amount||this.salary)?.toString()??"" ,      
      "Employment Type":(this.emp_type||this.employment_type)??"",
      "Existing KYC Flag": this.kyc_webengage??"",
      "Existing Mandate Flag":this.nach??"",
      "Insurance Amount":(this.insurance_premium1)??"",
      "Carry Forward Flag":this.carry_forward??"",
      "CPV Flag":this.stp_flag??"",
      "Insurance Flag":this.insurance_flag1??""

    });
   
    // this.insurance_opted=true

     const body1 = {
            Request_Key: "",
            Mobile: sessionStorage.getItem("MobileNumber"),
            Event_Name: "Nudge Insurance opted",
            Event_Type: "API",
            Origin: "Frontend",
            Partner_Name: "DMI Finance",
            Remark_1: "",
            Remark_2: "",
            Remark_3: "",
            Remark_4: "",
            Remark_5: "",
          };

          this.service.getEventTrack(body1).subscribe((res) => {});
    this.isFingoldconfirmed=true;
            const body = {
              Application_ID: sessionStorage.getItem("Application_id"),
              request_insurance_loan: true,
            };
            this.service.setInsurance(body).subscribe((res) => {
              this.isSkipInsurance=true
            });
          }
}

